<template>
  <main class="main_plan_container">
    <header class="header_container">
      <section class="header_content clearfix">
        <a class="header_jetfi_logo"></a>
        <nav class="header_nav">
          <ul>
            <li class="languages">
              <a>
                <p class="choose" v-on:click="toggleLangList()">
                  Language 語言
                </p>
                <div class="sub_item" v-if="showLangList">
                  <div class="sub_list">
                    <!-- <p v-on:click="changeLanguage('tw')">繁體中文</p> -->
                    <p v-on:click="changeLanguage('en')">English</p>
                    <p v-on:click="changeLanguage('ja')">日本語</p>
                  </div>
                </div>
              </a>
            </li>
            <!-- <li class="currency">
              <a>
                <p class="choose" v-on:click="toggleCurrencyList()">{{currency}}</p>
                <div class="sub_item" v-if="showCurrencyList">
                  <div class="sub_list">
                    <router-link to="/ntd"><p>{{$t("NTD")}}</p></router-link> 
                    <router-link to="/usd"><p>{{$t("USD")}}</p></router-link> 
                  </div>
                </div>
              </a>
            </li>-->
          </ul>
        </nav>
      </section>
    </header>
    <section class="area_content">
      <!-- <h3 class="top_title">{{$t("Data Store / Data Package")}}</h3> -->

      <!-- <a href="javascript:" v-on:click="changeLanguage('tw')">TW</a> -->
      <!-- <a href="javascript:" v-on:click="changeLanguage('en')">EN</a> -->
      <div class="area_menu">
        <!-- <div class="search_box">
					<input class="search_key_words" type="text" name="" placeholder="搜尋國家及地區">
        </div>-->
        <ul class="choose_area">
          <li>
            <p>{{ $t("country or region") }}：</p>
          </li>
          <li class="area_01">
            <p v-bind:class="{ btn_in: activeTab.asia }">
              <a v-on:click="changeTab('asia')" href="javascript:">{{
                $t("Asia")
              }}</a>
            </p>
          </li>
          <li class="area_02">
            <p v-bind:class="{ btn_in: activeTab.europe }">
              <a v-on:click="changeTab('europe')" href="javascript:">{{
                $t("Europe")
              }}</a>
            </p>
          </li>
          <li class="area_03">
            <p v-bind:class="{ btn_in: activeTab.africa }">
              <a v-on:click="changeTab('africa')" href="javascript:">{{
                $t("Africa")
              }}</a>
            </p>
          </li>
          <li class="area_04">
            <p v-bind:class="{ btn_in: activeTab.oceania }">
              <a v-on:click="changeTab('oceania')" href="javascript:">{{
                $t("Oceania")
              }}</a>
            </p>
          </li>
          <li class="area_05">
            <p v-bind:class="{ btn_in: activeTab.northAmerica }">
              <a v-on:click="changeTab('northAmerica')" href="javascript:">{{
                $t("North America")
              }}</a>
            </p>
          </li>
          <li class="area_06">
            <p v-bind:class="{ btn_in: activeTab.southAmerica }">
              <a v-on:click="changeTab('southAmerica')" href="javascript:">{{
                $t("South America")
              }}</a>
            </p>
          </li>
          <li class="area_07">
            <p v-bind:class="{ btn_in: activeTab.southAmerica }">
              <a v-on:click="changeTab('global')" href="javascript:">{{
                $t("Global")
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'asia'"
          class="choose_country"
          id="area_01_content"
          style="display: block;"
        >
          <li class="top_hot_country">
            <p>
              {{ $t("Popular Destinations") }}：
              <a href="javascript:" v-on:click="changeCountry('JP')">{{
                $t("Japan")
              }}</a>
              <a href="javascript:" v-on:click="changeCountry('TH')">{{
                $t("Thailand")
              }}</a>
              <a href="javascript:" v-on:click="changeCountry('CN')">{{
                $t("China")
              }}</a>
              <a href="javascript:" v-on:click="changeCountry('HK')">{{
                $t("Hong Kong")
              }}</a>
            </p>
          </li>
          <li v-for="c in asia.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'europe'"
          class="choose_country"
          id="area_01_content"
          style="display: block;"
        >
          <li class="top_hot_country">
            <p>
              {{ $t("Popular Destinations") }}：
              <a href="javascript:" v-on:click="changeCountry('DE')">{{
                $t("Germany")
              }}</a>
              <a href="javascript:" v-on:click="changeCountry('GB')">{{
                $t("United Kingdom")
              }}</a>
            </p>
          </li>
          <li v-for="c in europe.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'africa'"
          class="choose_country"
          id="area_01_content"
        >
          <li class="top_hot_country">
            <p>
              {{ $t("Popular Destinations") }}：
              <a href="javascript:" v-on:click="changeCountry('EG')">{{
                $t("Egypt")
              }}</a>
            </p>
          </li>
          <li v-for="c in africa.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'oceania'"
          class="choose_country"
          id="area_01_content"
        >
          <li v-for="c in oceania.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'northAmerica'"
          class="choose_country"
          id="area_01_content"
        >
          <li class="top_hot_country">
            <p>
              {{ $t("Popular Destinations") }}：
              <a href="javascript:" v-on:click="changeCountry('US')">{{
                $t("United States")
              }}</a>
            </p>
          </li>
          <li v-for="c in northAmerica.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'southAmerica'"
          class="choose_country"
          id="area_01_content"
        >
          <li v-for="c in southAmerica.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'global'"
          class="choose_country"
          id="area_01_content"
        >
          <li v-for="c in global.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{
                $t(c.en)
              }}</a>
            </p>
          </li>
        </ul>
      </div>
    </section>
    <section class="set_content">
      <h3 class="top_title">{{ $t("Unlimited / Data Package") }}</h3>
      <ul class="menu_list clearfix">
        <!-- <li v-for="item in plans[currency][language][selectedCountry]" v-bind:key="item.id"> -->
        <li v-for="item in selectedPlans[selectedCountry]" v-bind:key="item.id">
          <a
            v-if="distributor && replaceMap[distributor][item.title]"
            v-bind:href="replaceMap[distributor][item.title].url"
          >
            <h4 class="set_title">{{ item.title }}</h4>
            <p class="label">
              <span v-for="l in item.labels" v-bind:key="l">{{ l }}</span>
            </p>
            <p class="price">{{ replaceMap[distributor][item.title].price }}</p>
          </a>
          <a v-else v-bind:href="item.url">
            <h4 class="set_title">{{ item.title }}</h4>
            <p class="label">
              <span v-for="l in item.labels" v-bind:key="l">{{ l }}</span>
            </p>
            <p class="price">{{ item.price }}</p>
          </a>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
export default {
  name: "Global",
  data() {
    return {
      distributor: null,
      replaceMap: {
        cal: {
          // 華航
          "Data Package Global 85 Countries": {
            price: "USD 73",
            url: "https://dl.gl/OoN9M3zKP",
          },
          "データチャージ 世界85か国プラン/年": {
            price: "USD 73",
            url: "https://dl.gl/OoN9M3zKP",
          },
          "Data Package China Monthly/10GB": {
            price: "USD 50",
            url: "https://dl.gl/vmaD0kZRQ",
          },
          "データチャージ 中国プラン/月": {
            price: "USD 50",
            url: "https://dl.gl/vmaD0kZRQ",
          },
          "Data Package Taiwan Monthly/ Unlimited": {
            price: "USD 16",
            url: "https://dl.gl/dRm0XXy7M",
          },
          "データチャージ 台湾プラン/月": {
            price: "USD 16",
            url: "https://dl.gl/dRm0XXy7M",
          },
        },
        eva: {
          "Data Package Global 85 Countries": {
            price: "USD 45",
            url: "https://dl.gl/1aQG4V6aM",
          },
          "データチャージ 世界85か国プラン/年": {
            price: "USD 45",
            url: "https://dl.gl/1aQG4V6aM",
          },
          "Data Package China Monthly/10GB": {
            price: "USD 50",
            url: "https://dl.gl/vmaD0kZRQ",
          },
          "データチャージ 中国プラン/月": {
            price: "USD 50",
            url: "https://dl.gl/vmaD0kZRQ",
          },
          "Data Package Taiwan Monthly/ Unlimited": {
            price: "USD 16",
            url: "https://dl.gl/dRm0XXy7M",
          },
          "データチャージ 台湾プラン/月": {
            price: "USD 16",
            url: "https://dl.gl/dRm0XXy7M",
          },
        },
      },
      area: "asia",
      activeTab: {
        asia: true,
        europe: false,
        africa: false,
        oceania: false,
        northAmerica: false,
        southAmerica: false,
        global: false,
      },
      showLangList: false,
      showCurrencyList: false,
      selectedCountry: "JP",
      language: "en",
      currency: "USD",
      selectedPlans: {},
      asia: {
        countries: [
          { code: "JP", en: "Japan", "zh-TW": "日本" },
          { code: "KR", en: "Korea", "zh-TW": "韓國" },
          { code: "CN", en: "China", "zh-TW": "中國" },
          { code: "TW", en: "Taiwan", "zh-TW": "台灣" }, // 國際版
          { code: "HK", en: "Hong Kong", "zh-TW": "香港" },
          { code: "MO", en: "Macao", "zh-TW": "澳門" },
          { code: "SG", en: "Singapore", "zh-TW": "新加坡" },
          { code: "MY", en: "Malaysia", "zh-TW": "馬來西亞" },
          { code: "TH", en: "Thailand", "zh-TW": "泰國" },
          { code: "VN", en: "VietNam", "zh-TW": "越南" },
          { code: "ID", en: "Indonesia", "zh-TW": "印尼" },
          { code: "PH", en: "Philippines", "zh-TW": "菲律賓" },
          { code: "KH", en: "Cambodia", "zh-TW": "柬埔寨" },
          { code: "LA", en: "Laos", "zh-TW": "寮國" },
          { code: "MM", en: "Myanmar", "zh-TW": "緬甸" },
          { code: "IN", en: "India", "zh-TW": "印度" },
          { code: "IL", en: "Israel", "zh-TW": "以色列" },
          { code: "BD", en: "Bangladesh", "zh-TW": "孟加拉" },
          { code: "LK", en: "Sri Lanka", "zh-TW": "斯里蘭卡" },
          { code: "NP", en: "Nepal", "zh-TW": "尼泊爾" },
          { code: "JO", en: "Jordan", "zh-TW": "約旦" },
          { code: "MN", en: "Mongolia", "zh-TW": "外蒙古" },
          { code: "QA", en: "Qatar", "zh-TW": "卡達" },
          { code: "SA", en: "Saudi Arabia", "zh-TW": "沙烏地阿拉伯" },
          { code: "BN", en: "Brunei", "zh-TW": "汶萊" },
          { code: "MV", en: "Maldives", "zh-TW": "馬爾地夫" },
          { code: "BH", en: "Bahrain", "zh-TW": "巴林" },
          { code: "PK", en: "Pakistan", "zh-TW": "巴基斯坦" },
          { code: "KZ", en: "Kazakhstan", "zh-TW": "哈薩克" },
          { code: "AE", en: "UAE", "zh-TW": "阿拉伯聯合大公國" },
          { code: "AZ", en: "Azerbaijan", "zh-TW": "亞塞拜然" },
          { code: "AM", en: "Armenia", "zh-TW": "亞美尼亞" },
          { code: "GE", en: "Georgia", "zh-TW": "喬治亞" },
          { code: "OM", en: "Oman", "zh-TW": "阿曼" },
          { code: "KW", en: "Kuwait", "zh-TW": "科威特" },
          { code: "TJ", en: "Tajikistan", "zh-TW": "塔吉克" },
        ],
      },
      europe: {
        countries: [
          { code: "AT", en: "Austria", "zh-TW": "奧地利" },
          { code: "BG", en: "Bulgaria", "zh-TW": "保加利亞" },
          { code: "CH", en: "Switzerland", "zh-TW": "瑞士" },
          { code: "CZ", en: "Czech Republic", "zh-TW": "捷克共和國" },
          { code: "DE", en: "Germany", "zh-TW": "德國" },
          { code: "DK", en: "Denmark", "zh-TW": "丹麥" },
          { code: "EE", en: "Estonia", "zh-TW": "愛沙尼亞" },
          { code: "ES", en: "Spain", "zh-TW": "西班牙" },
          { code: "FI", en: "Finland", "zh-TW": "芬蘭" },
          { code: "FR", en: "France", "zh-TW": "法國" },
          { code: "GB", en: "United Kingdom", "zh-TW": "英國" },
          { code: "HR", en: "Croatia", "zh-TW": "克羅埃西亞" },
          { code: "IE", en: "Ireland", "zh-TW": "愛爾蘭" },
          { code: "IS", en: "Iceland", "zh-TW": "冰島" },
          { code: "IT", en: "Italy", "zh-TW": "義大利" },
          { code: "LV", en: "Latvia", "zh-TW": "拉脫維亞" },
          { code: "MT", en: "Malta", "zh-TW": "馬爾他" },
          { code: "NO", en: "Norway", "zh-TW": "挪威" },
          { code: "PL", en: "Poland", "zh-TW": "波蘭" },
          { code: "PT", en: "Portugal", "zh-TW": "葡萄牙" },
          { code: "RO", en: "Romania", "zh-TW": "羅馬尼亞" },
          { code: "RU", en: "Russia", "zh-TW": "俄羅斯" },
          { code: "SE", en: "Sweden", "zh-TW": "瑞典" },
          { code: "SI", en: "Slovenia", "zh-TW": "斯洛維尼亞" },
          { code: "SK", en: "Slovakia", "zh-TW": "斯洛伐克" },
          { code: "TR", en: "Turkey", "zh-TW": "土耳其" },
          { code: "UA", en: "Ukraine", "zh-TW": "烏克蘭" },
          { code: "LI", en: "Liechtenstein", "zh-TW": "列支敦士登" },
          { code: "VA", en: "Vatican", "zh-TW": "梵蒂岡" },
          { code: "MC", en: "Monaco", "zh-TW": "摩納哥" },
          { code: "AX", en: "Åland Islands", "zh-TW": "奧蘭群島" },
          { code: "SM", en: "San Marino", "zh-TW": "聖馬利諾" },
          { code: "NL", en: "Netherlands", "zh-TW": "荷蘭" },
          { code: "BE", en: "Belgium", "zh-TW": "比利時" },
          { code: "LU", en: "Luxembourg", "zh-TW": "盧森堡" },
          { code: "CY", en: "Cyprus", "zh-TW": "賽普勒斯" },
          { code: "GR", en: "Greece", "zh-TW": "希臘" },
          { code: "HU", en: "Hungary", "zh-TW": "匈牙利" },
          { code: "LT", en: "Lithuania", "zh-TW": "立陶宛" },
          { code: "RS", en: "Serbia", "zh-TW": "塞爾維亞" },
          { code: "ME", en: "Montenegro", "zh-TW": "蒙特內哥羅" },
          { code: "GG", en: "Guernsey", "zh-TW": "根西島" },
          { code: "JE", en: "Jersey", "zh-TW": "澤西島" },
          { code: "IM", en: "Isle of man", "zh-TW": "曼島" },
          {
            code: "BA",
            en: "Bosnia and Herzegovina",
            "zh-TW": "波士尼亞赫塞哥維納",
          },
          { code: "GI", en: "Gibraltar", "zh-TW": "直布羅陀" },
          { code: "AL", en: "Albania", "zh-TW": "阿爾巴尼亞" },
          { code: "MK", en: "Macedonia", "zh-TW": "馬其頓" },
        ],
      },
      africa: {
        countries: [
          { code: "EG", en: "Egypt", "zh-TW": "埃及" },
          { code: "MA", en: "Morocco", "zh-TW": "摩洛哥" },
          { code: "KE", en: "Kenya", "zh-TW": "肯亞" },
          { code: "EH", en: "Western Sahara", "zh-TW": "西撒哈拉" },
          { code: "GH", en: "Ghana", "zh-TW": "迦納" },
          { code: "ZA", en: "South Africa", "zh-TW": "南非" },
          { code: "MG", en: "Madagascar", "zh-TW": "馬達加斯加" },
          { code: "DZ", en: "Algeria", "zh-TW": "阿爾及利亞" },
          { code: "ZM", en: "Zambia", "zh-TW": "尚比亞" },
          { code: "MU", en: "Mauritius", "zh-TW": "模里西斯" },
          { code: "NG", en: "Nigeria", "zh-TW": "奈及利亞" },
          { code: "TN", en: "Tunisia", "zh-TW": "突尼斯" },
          { code: "TZ", en: "Tanzania", "zh-TW": "坦尚尼亞" },
          { code: "AO", en: "Angola", "zh-TW": "安哥拉" },
        ],
      },
      oceania: {
        countries: [
          { code: "AU", en: "Australia", "zh-TW": "澳洲" },
          { code: "NZ", en: "New Zealand", "zh-TW": "紐西蘭" },
          { code: "FJ", en: "Fiji", "zh-TW": "斐濟" },
          { code: "GU", en: "Guam", "zh-TW": "關島" },
          { code: "MP", en: "Saipan", "zh-TW": "塞班" },
        ],
      },
      northAmerica: {
        countries: [
          { code: "US", en: "United States", "zh-TW": "美國" },
          { code: "CA", en: "Canada", "zh-TW": "加拿大" },
          { code: "MX", en: "Mexico", "zh-TW": "墨西哥" },
          { code: "PR", en: "Puerto Rico", "zh-TW": "波多黎各" },
          { code: "GP", en: "Guadeloupe", "zh-TW": "瓜德魯普" },
          { code: "MF", en: "Saint Martin", "zh-TW": "聖馬丁" },
          { code: "AG", en: "Antigua and Barbuda", "zh-TW": "安地卡及巴布達" },
          { code: "AW", en: "Aruba", "zh-TW": "阿魯巴" },
          { code: "KY", en: "Cayman Islands", "zh-TW": "開曼群島" },
          { code: "CW", en: "Curacao", "zh-TW": "庫拉索島" },
          { code: "GD", en: "Grenada", "zh-TW": "格瑞那達" },
          { code: "HT", en: "Haiti", "zh-TW": "海地" },
          { code: "JM", en: "Jamaica", "zh-TW": "牙買加" },
          { code: "TT", en: "Trinidad and Tobago", "zh-TW": "千里達" },
          {
            code: "TC",
            en: "Turks and Caicos Islands",
            "zh-TW": "特克斯和凱科斯群島",
          },
          { code: "MQ", en: "Martinique", "zh-TW": "法屬馬丁尼克" },
          { code: "AI", en: "Anguilla", "zh-TW": "安圭拉" },
          { code: "VG", en: "British Virgin Islands", "zh-TW": "英屬維京群島" },
          {
            code: "VC",
            en: "Saint Vincent and the Grenadines",
            "zh-TW": "聖文森特及格林納丁斯",
          },
        ],
      },
      southAmerica: {
        countries: [
          { code: "AR", en: "Argentina", "zh-TW": "阿根廷" },
          { code: "BR", en: "Brazil", "zh-TW": "巴西" },
          { code: "PE", en: "Peru", "zh-TW": "秘魯" },
          { code: "CO", en: "Colombia", "zh-TW": "哥倫比亞" },
          { code: "UY", en: "Uruguay", "zh-TW": "烏拉圭" },
          { code: "VE", en: "Venezuela", "zh-TW": "委內瑞拉" },
          { code: "GY", en: "Guyana", "zh-TW": "圭亞那" },
          { code: "PA", en: "Panama", "zh-TW": "巴拿馬" },
          { code: "CL", en: "Chile", "zh-TW": "智利" },
          { code: "BO", en: "Bolivia", "zh-TW": "玻利維亞" },
          { code: "CR", en: "Costa Rica", "zh-TW": "哥斯大黎加" },
          { code: "SR", en: "Suriname", "zh-TW": "蘇利南" },
          { code: "EC", en: "Ecuador", "zh-TW": "厄瓜多爾" },
          {
            code: "DO",
            en: "The Dominican Republic",
            "zh-TW": "多明尼加共和國",
          },
          { code: "GT", en: "Guatemala", "zh-TW": "瓜地馬拉" },
          { code: "NI", en: "Nicaragua", "zh-TW": "尼加拉瓜" },
          { code: "SV", en: "El Salvador", "zh-TW": "薩爾瓦多" },
        ],
      },
      global: {
        countries: [{ code: "GLOBAL", en: "Global", "zh-TW": "全球" }],
      },
      plans: {
        // NTD: {
        //   tw: {
        //     GLOBAL: [
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     JP: [
        //       {
        //         title: "日本 單國套餐",
        //         price: "NTD 69",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/1aKma2Y9O"
        //       },
        //       {
        //         title: "日韓吃到飽",
        //         price: "NTD 69",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/BpyALBbgk"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     KR: [
        //       {
        //         title: "韓國 單國套餐",
        //         price: "NTD 69",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/LL3a6LmlN"
        //       },
        //       {
        //         title: "日韓吃到飽",
        //         price: "NTD 69",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/BpyALBbgk"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CN: [
        //       {
        //         title: "中國 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Nlb8R8ZdZ"
        //       },
        //       {
        //         title: "中國 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/LL3a8mXJv"
        //       },
        //       {
        //         title: "中國 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/aNXYk4XaQ"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "中俄500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ynl8wmB4L"
        //       },
        //       {
        //         title: "中俄1GB",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/aNXYkeXZQ"
        //       },
        //       {
        //         title: "中俄吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/Oo5LRvOzL"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     HK: [
        //       {
        //         title: "香港 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ZENYQYK72"
        //       },
        //       {
        //         title: "香港 單國套餐",
        //         price: "NTD 139",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/1aKmAaOk6"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MO: [
        //       {
        //         title: "澳門 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/nVG1P1zwL"
        //       },
        //       {
        //         title: "澳門 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7o7DDB"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SG: [
        //       {
        //         title: "新加坡 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/QVlaVBe4Q"
        //       },
        //       {
        //         title: "新加坡 單國套餐",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/pVnA1Vp8l"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "新馬泰越吃到飽",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MY: [
        //       {
        //         title: "馬來西亞 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/dRo6O6Xwy"
        //       },
        //       {
        //         title: "馬來西亞 單國套餐",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/LL3a6LBvv"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "新馬泰越吃到飽",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TH: [
        //       {
        //         title: "泰國 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/AAYRzJkN7"
        //       },
        //       {
        //         title: "泰國 單國套餐",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/vmb1OmzMl"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "新馬泰越吃到飽",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     VN: [
        //       {
        //         title: "越南 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/RLDm4Lr6J"
        //       },
        //       {
        //         title: "越南 單國套餐",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/ZENYQYgl9"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "新馬泰越吃到飽",
        //         price: "NTD 99",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     ID: [
        //       {
        //         title: "印尼 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Nlb8R8Eml"
        //       },
        //       {
        //         title: "印尼 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28R4l0z"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PH: [
        //       {
        //         title: "菲律賓 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/VY8m4mvka"
        //       },
        //       {
        //         title: "菲律賓 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/ynl8w8AoL"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     KH: [
        //       {
        //         title: "柬埔寨 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/wG5mPDRQz"
        //       },
        //       {
        //         title: "柬埔寨 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/6bZX1BaBy"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LA: [
        //       {
        //         title: "寮國 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/llLXPXaYB"
        //       },
        //       {
        //         title: "寮國 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RK9rl"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MM: [
        //       {
        //         title: "緬甸 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvR0Pp"
        //       },
        //       {
        //         title: "緬甸 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/QVladVRJo"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IN: [
        //       {
        //         title: "印度 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/796DmD7KD"
        //       },
        //       {
        //         title: "印度 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RKY51"
        //       },
        //       {
        //         title: "中國+東南亞10國",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "中國+東南亞6國",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IL: [
        //       {
        //         title: "以色列 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/9KXv9vEZ1"
        //       },
        //       {
        //         title: "以色列 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/6bZXmbGJy"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BD: [
        //       {
        //         title: "孟加拉 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/kLgMbMlnY"
        //       },
        //       {
        //         title: "孟加拉 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/2rNd0rrKO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LK: [
        //       {
        //         title: "斯里蘭卡 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/dRo6O6pGZ"
        //       },
        //       {
        //         title: "斯里蘭卡 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/RLDm4Lkwn"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NP: [
        //       {
        //         title: "尼泊爾 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/2rNd0d5X4"
        //       },
        //       {
        //         title: "尼泊爾 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/llLXgYkEa"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     JO: [
        //       {
        //         title: "約旦 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/QVladazp0"
        //       },
        //       {
        //         title: "約旦 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6Y4nMG"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MN: [
        //       {
        //         title: "外蒙古 單國套餐",
        //         price: "NTD 80",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Epz8L8BQJ"
        //       },
        //       {
        //         title: "外蒙古 單國套餐",
        //         price: "NTD 155",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/dRo6OR6BY"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     QA: [
        //       {
        //         title: "卡達 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Oo5LRLMM8"
        //       },
        //       {
        //         title: "卡達 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/4aA0zaZ5y"
        //       }
        //     ],
        //     SA: [
        //       {
        //         title: "沙烏地阿拉伯 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/4aA0z0MJK"
        //       },
        //       {
        //         title: "沙烏地阿拉伯 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/LL3a6LpM5"
        //       }
        //     ],
        //     BN: [
        //       {
        //         title: "汶萊 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/4aA0z04Yz"
        //       },
        //       {
        //         title: "汶萊 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/QVladV2BR"
        //       }
        //     ],
        //     MV: [
        //       {
        //         title: "馬爾地夫 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/J4w6Y6aBp"
        //       },
        //       {
        //         title: "馬爾地夫 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/QVladVG00"
        //       }
        //     ],
        //     BH: [
        //       {
        //         title: "巴林 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/BpyALAp5K"
        //       },
        //       {
        //         title: "巴林 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7oQgYl"
        //       }
        //     ],
        //     PK: [
        //       {
        //         title: "巴基斯坦 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/G4OpLpmbZ"
        //       },
        //       {
        //         title: "巴基斯坦 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/kLgMbL8p3"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     KZ: [
        //       {
        //         title: "哈薩克 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/5Qd7oQRYa"
        //       },
        //       {
        //         title: "哈薩克 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/4aA0zarrZ"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AE: [
        //       {
        //         title: "阿拉伯聯合大公國 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/pVnA1Vklw"
        //       },
        //       {
        //         title: "阿拉伯聯合大公國 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6Y4GKa"
        //       }
        //     ],
        //     AZ: [
        //       {
        //         title: "亞塞拜然 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/2rNd0apre"
        //       },
        //       {
        //         title: "亞塞拜然 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/6bZXmbbNy"
        //       }
        //     ],
        //     AM: [
        //       {
        //         title: "亞美尼亞 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/nVG1PV28J"
        //       },
        //       {
        //         title: "亞美尼亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Nlb8R47ze"
        //       }
        //     ],
        //     GE: [
        //       {
        //         title: "喬治亞 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/zeD9EeAG2"
        //       },
        //       {
        //         title: "喬治亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/vmb1OmLwK"
        //       }
        //     ],
        //     OM: [
        //       {
        //         title: "阿曼 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ynl8wno6l"
        //       },
        //       {
        //         title: "阿曼 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Epz8La50v"
        //       }
        //     ],
        //     KW: [
        //       {
        //         title: "科威特 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/llLXPlMok"
        //       },
        //       {
        //         title: "科威特 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/nVG1P8GBJ"
        //       }
        //     ],
        //     TJ: [
        //       {
        //         title: "塔吉克 單國套餐",
        //         price: "NTD 279",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/aNXYkNpPk"
        //       },
        //       {
        //         title: "塔吉克 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/2rNd0OmQO"
        //       }
        //     ],
        //     AT: [
        //       {
        //         title: "奧地利 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/0opLBL3bp"
        //       },
        //       {
        //         title: "奧地利 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/PVMZLvwKB"
        //       },
        //       {
        //         title: "奧地利 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/J4w6Yv0LD"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BG: [
        //       {
        //         title: "保加利亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/G4OpLpozR"
        //       },
        //       {
        //         title: "保加利亞 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "ttps://dl.gl/nVG1P85B4"
        //       },
        //       {
        //         title: "保加利亞 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/9KXv9oEB1"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CH: [
        //       {
        //         title: "瑞士 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/pVnA1AQ1l"
        //       },
        //       {
        //         title: "瑞士 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/RLDm49DAm"
        //       },
        //       {
        //         title: "瑞士 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/YmKYAB8lB"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CZ: [
        //       {
        //         title: "捷克共和國 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/PVMZLZkmO"
        //       },
        //       {
        //         title: "捷克共和國 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/4aA0zd9l8"
        //       },
        //       {
        //         title: "捷克共和國 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/kLgMbR9zQ"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     DE: [
        //       {
        //         title: "德國 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/vmb1O18gY"
        //       },
        //       {
        //         title: "德國 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/LL3a6KN0M"
        //       },
        //       {
        //         title: "德國 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/RLDm49KRn"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     DK: [
        //       {
        //         title: "丹麥 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/829ama3eE"
        //       },
        //       {
        //         title: "丹麥 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7o0yOG"
        //       },
        //       {
        //         title: "丹麥 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/1aKmAGVwr"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     EE: [
        //       {
        //         title: "愛沙尼亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/rRw1APLK5"
        //       },
        //       {
        //         title: "愛沙尼亞 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/llLXPm2Gr"
        //       },
        //       {
        //         title: "愛沙尼亞 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/KbEmRmKyp"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     ES: [
        //       {
        //         title: "西班牙 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/gmPzwzKNz"
        //       },
        //       {
        //         title: "西班牙 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/gmPzwN69l"
        //       },
        //       {
        //         title: "西班牙 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/KbEmRv81Y"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     FI: [
        //       {
        //         title: "芬蘭 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/829amaywO"
        //       },
        //       {
        //         title: "芬蘭 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/brmRvyBXm"
        //       },
        //       {
        //         title: "芬蘭 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/5Qd7oZkAa"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     FR: [
        //       {
        //         title: "法國 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvRNYK"
        //       },
        //       {
        //         title: "法國 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/2rNd0O2JJ"
        //       },
        //       {
        //         title: "法國 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/llLXV0KmO"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     GB: [
        //       {
        //         title: "英國 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/zeD9E9N7O"
        //       },
        //       {
        //         title: "英國 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/2rNd0O8A1"
        //       },
        //       {
        //         title: "英國 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/3badobXA0"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     HR: [
        //       {
        //         title: "克羅埃西亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ynl8w8Dy6"
        //       },
        //       {
        //         title: "克羅埃西亞 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6982yp"
        //       },
        //       {
        //         title: "克羅埃西亞 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/QVla3Z2MX"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IE: [
        //       {
        //         title: "愛爾蘭 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/vmb1O1zY2"
        //       },
        //       {
        //         title: "愛爾蘭 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/YmKYABZpV"
        //       },
        //       {
        //         title: "愛爾蘭 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/e8r2n1oDZ"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IS: [
        //       {
        //         title: "冰島 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/QVladZRNQ"
        //       },
        //       {
        //         title: "冰島 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/pVnA1PrBO"
        //       },
        //       {
        //         title: "冰島 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/wG5mnAZ6V"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IT: [
        //       {
        //         title: "義大利 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKmAmk2g"
        //       },
        //       {
        //         title: "義大利 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/e8r2n1N19"
        //       },
        //       {
        //         title: "義大利 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/gmPzwDgvD"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LV: [
        //       {
        //         title: "拉脫維亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/LL3a6aO4m"
        //       },
        //       {
        //         title: "拉脫維亞 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/ynl8wbR3l"
        //       },
        //       {
        //         title: "拉脫維亞 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/PVMZLGRzL"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MT: [
        //       {
        //         title: "馬爾他 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/BpyAlm9G6"
        //       },
        //       {
        //         title: "馬爾他 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Nlb8R4mbb"
        //       },
        //       {
        //         title: "馬爾他 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/kLgMbR433"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NO: [
        //       {
        //         title: "挪威 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: 'link":"https://dl.gl/ynl8w84LB'
        //       },
        //       {
        //         title: "挪威 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/rRw1KRovY"
        //       },
        //       {
        //         title: "挪威 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/KbEmRvgve"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PL: [
        //       {
        //         title: "波蘭 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/5Qd7o75Ma"
        //       },
        //       {
        //         title: "波蘭 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/6bZXmdblp"
        //       },
        //       {
        //         title: "波蘭 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/e8r2n1arw"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PT: [
        //       {
        //         title: "葡萄牙 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2n2BBb"
        //       },
        //       {
        //         title: "葡萄牙 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7o0DV7"
        //       },
        //       {
        //         title: "葡萄牙 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/pVnA1P8bQ"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     RO: [
        //       {
        //         title: "羅馬尼亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/5Qd7p2bz5"
        //       },
        //       {
        //         title: "羅馬尼亞 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28ReK0g"
        //       },
        //       {
        //         title: "羅馬尼亞 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/kLgMbRZ07"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     RU: [
        //       {
        //         title: "俄羅斯 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmXvAD"
        //       },
        //       {
        //         title: "俄羅斯 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6YGK6Z"
        //       },
        //       {
        //         title: "俄羅斯 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/brmRvy3Yr"
        //       },
        //       {
        //         title: "中俄500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ynl8wmB4L"
        //       },
        //       {
        //         title: "中俄1GB",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/aNXYkeXZQ"
        //       },
        //       {
        //         title: "中俄吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/Oo5LRvOzL"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SE: [
        //       {
        //         title: "瑞典 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXm79GQ"
        //       },
        //       {
        //         title: "瑞典 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/3badonp4p"
        //       },
        //       {
        //         title: "瑞典 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/aNXYnGplv"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SI: [
        //       {
        //         title: "斯洛維尼亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/9KXv9v1w8"
        //       },
        //       {
        //         title: "斯洛維尼亞 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRMzKLX"
        //       },
        //       {
        //         title: "斯洛維尼亞 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/wG5mnAZAN"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SK: [
        //       {
        //         title: "斯洛伐克 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmX89X"
        //       },
        //       {
        //         title: "斯洛伐克 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/wG5mnArBG"
        //       },
        //       {
        //         title: "斯洛伐克 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/RLDm2BYg4"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TR: [
        //       {
        //         title: "土耳其 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKmAmvwv"
        //       },
        //       {
        //         title: "土耳其 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Oo5LR9RdL"
        //       },
        //       {
        //         title: "土耳其 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/llLXPRkPE"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     UA: [
        //       {
        //         title: "烏克蘭 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvRdQ8"
        //       },
        //       {
        //         title: "烏克蘭 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRL02yX"
        //       },
        //       {
        //         title: "烏克蘭 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/aNXYnkZw1"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LI: [
        //       {
        //         title: "列支敦士登 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/QVladaNZl"
        //       },
        //       {
        //         title: "列支敦士登 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/1aKmAGO9v"
        //       },
        //       {
        //         title: "列支敦士登 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/XvpYJokmO"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     VA: [
        //       {
        //         title: "梵蒂岡 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/gmPzwz5Dz"
        //       },
        //       {
        //         title: "梵蒂岡 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/3badono70"
        //       },
        //       {
        //         title: "梵蒂岡 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/3badonPym"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MC: [
        //       {
        //         title: "摩納哥 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/llLXPX7Pr"
        //       },
        //       {
        //         title: "摩納哥 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/aNXYk4Dov"
        //       },
        //       {
        //         title: "摩納哥 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/vmb1OLavG"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AX: [
        //       {
        //         title: "奧蘭群島 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/aNXYkYmrQ"
        //       },
        //       {
        //         title: "奧蘭群島 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/e8r2n1k59"
        //       },
        //       {
        //         title: "奧蘭群島 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/4aA0RQZ58"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SM: [
        //       {
        //         title: "聖馬利諾 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvR298"
        //       },
        //       {
        //         title: "聖馬利諾 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/BpyALmXJm"
        //       },
        //       {
        //         title: "聖馬利諾 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/LL3aO9dZg"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NL: [
        //       {
        //         title: "荷蘭 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/m1zLMLOp9"
        //       },
        //       {
        //         title: "荷蘭 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/LL3a6KBym"
        //       },
        //       {
        //         title: "荷蘭 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/3badoneG0"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BE: [
        //       {
        //         title: "比利時 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKmAmA0Z"
        //       },
        //       {
        //         title: "比利時 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/ynl8wG2a6"
        //       },
        //       {
        //         title: "比利時 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/brmRvy9rr"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LU: [
        //       {
        //         title: "盧森堡 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/llLXPXy7o"
        //       },
        //       {
        //         title: "盧森堡 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/m1zLkYEJ9"
        //       },
        //       {
        //         title: "盧森堡 單國套餐",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/QVladOgPk"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "歐洲35國吃到飽",
        //         price: "NTD 250",
        //         labels: ["1天", "吃到飽"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CY: [
        //       {
        //         title: "賽普勒斯 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/wG5mnmyrg"
        //       },
        //       {
        //         title: "賽普勒斯 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/4aA0zdLEN"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     GR: [
        //       {
        //         title: "希臘 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ZENYQY8KN"
        //       },
        //       {
        //         title: "希臘 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/vmb1OLm0G"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     HU: [
        //       {
        //         title: "匈牙利 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/kLgMbMplQ"
        //       },
        //       {
        //         title: "匈牙利 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/XvpYJeOVD"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LT: [
        //       {
        //         title: "立陶宛 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Epz8L8nYw"
        //       },
        //       {
        //         title: "立陶宛 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/brmRvamV0"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     RS: [
        //       {
        //         title: "塞爾維亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/AAYRME8ZK"
        //       },
        //       {
        //         title: "塞爾維亞 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/VY8m4P8Ja"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     ME: [
        //       {
        //         title: "蒙特內哥羅 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/AAYRLREPX"
        //       },
        //       {
        //         title: "蒙特內哥羅 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/kLgMbY9m1"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     GG: [
        //       {
        //         title: "根西島 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Nlb8R8OmO"
        //       },
        //       {
        //         title: "根西島 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/aNXYkRPVZ"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     JE: [
        //       {
        //         title: "澤西島 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/rRw1A1A4L"
        //       },
        //       {
        //         title: "澤西島 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/nVG1PmwrY"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IM: [
        //       {
        //         title: "曼島 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ZENYQY8Jv"
        //       },
        //       {
        //         title: "曼島 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/829am699Y"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BA: [
        //       {
        //         title: "波士尼亞赫塞哥維納 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKmAebLv"
        //       },
        //       {
        //         title: "波士尼亞赫塞哥維納 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/3badoQzKp"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     GI: [
        //       {
        //         title: "直布羅陀 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoEMap"
        //       },
        //       {
        //         title: "直布羅陀 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/829am67K2"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     AL: [
        //       {
        //         title: "阿爾巴尼亞 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/XvpYJvZkQ"
        //       },
        //       {
        //         title: "阿爾巴尼亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Epz8Ll28g"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MK: [
        //       {
        //         title: "馬其頓 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/LL3a6Llb7"
        //       },
        //       {
        //         title: "馬其頓 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Epz8LlPgy"
        //       },
        //       {
        //         title: "歐洲48國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "歐洲48國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     EG: [
        //       {
        //         title: "埃及 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badodnzQ"
        //       },
        //       {
        //         title: "埃及 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/llLXP6ayo"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MA: [
        //       {
        //         title: "摩洛哥 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/kLgMbML81"
        //       },
        //       {
        //         title: "摩洛哥 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/1aKmArwGO"
        //       }
        //     ],
        //     KE: [
        //       {
        //         title: "肯亞 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/QVladVBJ0"
        //       },
        //       {
        //         title: "肯亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Oo5LRvDN8"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     EH: [
        //       {
        //         title: "西撒哈拉 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/okODLkVNJ"
        //       },
        //       {
        //         title: "西撒哈拉 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/G4OpLmkRM"
        //       }
        //     ],
        //     GH: [
        //       {
        //         title: "迦納 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/G4Op8NR6M"
        //       },
        //       {
        //         title: "迦納 單國套餐",
        //         price: "NTD 369",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/BpyALdk71"
        //       }
        //     ],
        //     ZA: [
        //       {
        //         title: "南非 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/796Dm9l5D"
        //       },
        //       {
        //         title: "南非 單國套餐",
        //         price: "NTD 369",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/e8r2nMJ8v"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MG: [
        //       {
        //         title: "馬達加斯加 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badobwop"
        //       },
        //       {
        //         title: "馬達加斯加 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/wG5mnXVVz"
        //       }
        //     ],
        //     DZ: [
        //       {
        //         title: "阿爾及利亞 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/dRo6ORVX1"
        //       },
        //       {
        //         title: "阿爾及利亞 單國套餐",
        //         price: "NTD 399",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/dRo6ONAeV"
        //       }
        //     ],
        //     ZM: [
        //       {
        //         title: "尚比亞 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvr4Qw"
        //       },
        //       {
        //         title: "尚比亞 單國套餐",
        //         price: "NTD 429",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/6bZXmdBLm"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MU: [
        //       {
        //         title: "模里西斯 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/G4OpL4mnZ"
        //       },
        //       {
        //         title: "模里西斯 單國套餐",
        //         price: "NTD 549",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/LL3a6vgbz"
        //       }
        //     ],
        //     NG: [
        //       {
        //         title: "奈及利亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badobA01"
        //       },
        //       {
        //         title: "奈及利亞 單國套餐",
        //         price: "NTD 549",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7oAOK7"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TN: [
        //       {
        //         title: "突尼斯 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/G4OpL4ezZ"
        //       },
        //       {
        //         title: "突尼斯 單國套餐",
        //         price: "NTD 549",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6YGEzZ"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TZ: [
        //       {
        //         title: "坦尚尼亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/zeD9EePB2"
        //       },
        //       {
        //         title: "坦尚尼亞 單國套餐",
        //         price: "NTD 549",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/XvpYJenOK"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AO: [
        //       {
        //         title: "安哥拉 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2n8YEk"
        //       },
        //       {
        //         title: "安哥拉 單國套餐",
        //         price: "NTD 789",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/zeD9E5z43"
        //       }
        //     ],
        //     AU: [
        //       {
        //         title: "澳洲 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/gmPzwzzKD"
        //       },
        //       {
        //         title: "澳洲 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/brmRva6Vn"
        //       },
        //       {
        //         title: "紐澳斐3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ"
        //       },
        //       {
        //         title: "紐澳斐3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/okODLme9G"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NZ: [
        //       {
        //         title: "紐西蘭 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/llLXPX55g"
        //       },
        //       {
        //         title: "紐西蘭 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/gmPzwYZ8w"
        //       },
        //       {
        //         title: "紐澳斐3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ"
        //       },
        //       {
        //         title: "紐澳斐3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/okODLme9G"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     FJ: [
        //       {
        //         title: "斐濟 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/9KXv9vKQ4"
        //       },
        //       {
        //         title: "斐濟 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/PVMZP7Va9"
        //       },
        //       {
        //         title: "紐澳斐3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ"
        //       },
        //       {
        //         title: "紐澳斐3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/okODLme9G"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     GU: [
        //       {
        //         title: "關島 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/YmKYAYaNP"
        //       },
        //       {
        //         title: "關島 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/okODLmemw"
        //       },
        //       {
        //         title: "關島塞班500MB",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoQZNY"
        //       },
        //       {
        //         title: "關島塞班1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7oAMnZ"
        //       }
        //     ],
        //     MP: [
        //       {
        //         title: "塞班 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvrX9w"
        //       },
        //       {
        //         title: "塞班 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/XvpYJe9LP"
        //       },
        //       {
        //         title: "關島塞班500MB",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badoQZNY"
        //       },
        //       {
        //         title: "關島塞班1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7oAMnZ"
        //       }
        //     ],
        //     US: [
        //       {
        //         title: "美國 單國套餐",
        //         price: "NTD 99",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvRnLK"
        //       },
        //       {
        //         title: "美國 單國套餐",
        //         price: "NTD 190",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/Epz8LlJJy"
        //       },
        //       {
        //         title: "美加墨3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv"
        //       },
        //       {
        //         title: "美加墨3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CA: [
        //       {
        //         title: "加拿大 單國套餐",
        //         price: "NTD 110",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/e8r2n2951"
        //       },
        //       {
        //         title: "加拿大 單國套餐",
        //         price: "NTD 215",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/vmb1OdJ7Q"
        //       },
        //       {
        //         title: "美加墨3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv"
        //       },
        //       {
        //         title: "美加墨3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MX: [
        //       {
        //         title: "墨西哥 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/9KXv9vvlM"
        //       },
        //       {
        //         title: "墨西哥 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/MK28ReQm1"
        //       },
        //       {
        //         title: "美加墨3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv"
        //       },
        //       {
        //         title: "美加墨3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PR: [
        //       {
        //         title: "波多黎各 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/PVMZLGYz2"
        //       },
        //       {
        //         title: "波多黎各 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/4aA0zewgK"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     GP: [
        //       {
        //         title: "瓜德魯普 單國套餐",
        //         price: "NTD 189",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/KbEmRmzwa"
        //       },
        //       {
        //         title: "瓜德魯普 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/nVG1Pm4lY"
        //       }
        //     ],
        //     MF: [
        //       {
        //         title: "聖馬丁 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/PVMZPaKLZ"
        //       },
        //       {
        //         title: "聖馬丁 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/vmb1OLKO2"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AG: [
        //       {
        //         title: "安地卡及巴布達 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/nVG1PVKXe"
        //       },
        //       {
        //         title: "安地卡及巴布達 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/nVG1PmbYb"
        //       }
        //     ],
        //     AW: [
        //       {
        //         title: "阿魯巴 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/brmRvrv4r"
        //       },
        //       {
        //         title: "阿魯巴 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/6bZXmdJB7"
        //       }
        //     ],
        //     KY: [
        //       {
        //         title: "開曼群島 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/wG5mnG6O5"
        //       },
        //       {
        //         title: "開曼群島 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/0opLBXKOA"
        //       }
        //     ],
        //     CW: [
        //       {
        //         title: "庫拉索島 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/QVladVGyo"
        //       },
        //       {
        //         title: "庫拉索島 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/796Dm3NkN"
        //       }
        //     ],
        //     GD: [
        //       {
        //         title: "格瑞那達 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Nlb8Rl8Gv"
        //       },
        //       {
        //         title: "格瑞那達 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/llLXPmD4O"
        //       }
        //     ],
        //     HT: [
        //       {
        //         title: "海地 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/829am2oln"
        //       },
        //       {
        //         title: "海地 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/pVnA1X4lQ"
        //       }
        //     ],
        //     JM: [
        //       {
        //         title: "牙買加 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/pVnA1VB4w"
        //       },
        //       {
        //         title: "牙買加 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/wG5mnXayz"
        //       }
        //     ],
        //     TT: [
        //       {
        //         title: "千里達 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/pVnAvl5X4"
        //       },
        //       {
        //         title: "千里達 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/3badoQZK1"
        //       }
        //     ],
        //     TC: [
        //       {
        //         title: "特克斯和凱科斯群島 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/nVG1PVBDm"
        //       },
        //       {
        //         title: "特克斯和凱科斯群島 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/2rNd0KnkR"
        //       }
        //     ],
        //     MQ: [
        //       {
        //         title: "法屬馬丁尼克 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ZENYQEmJB"
        //       },
        //       {
        //         title: "法屬馬丁尼克 單國套餐",
        //         price: "NTD 699",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/G4OpLml0R"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AI: [
        //       {
        //         title: "安圭拉 單國套餐",
        //         price: "NTD 489",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/KbEmRb3NL"
        //       },
        //       {
        //         title: "安圭拉 單國套餐",
        //         price: "NTD 819",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/ZENYQP4y1"
        //       }
        //     ],
        //     VG: [
        //       {
        //         title: "英屬維京群島 單國套餐",
        //         price: "NTD 489",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmb0m8"
        //       },
        //       {
        //         title: "英屬維京群島 單國套餐",
        //         price: "NTD 819",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/5Qd7oA1vl"
        //       }
        //     ],
        //     VC: [
        //       {
        //         title: "聖文森特及格林納丁斯 單國套餐",
        //         price: "NTD 489",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/AAYRLA573"
        //       },
        //       {
        //         title: "聖文森特及格林納丁斯 單國套餐",
        //         price: "NTD 819",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/nVG1Pmgpe"
        //       }
        //     ],
        //     AR: [
        //       {
        //         title: "阿根廷 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/Epz8L8dgL"
        //       },
        //       {
        //         title: "阿根廷 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/DKLB0MXZV"
        //       },
        //       {
        //         title: "阿根廷巴西秘魯3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm"
        //       },
        //       {
        //         title: "阿根廷巴西秘魯3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/1aKmArk37"
        //       }
        //     ],
        //     BR: [
        //       {
        //         title: "巴西 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/YmKYe301n"
        //       },
        //       {
        //         title: "巴西 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/XvpYJa4MK"
        //       },
        //       {
        //         title: "阿根廷巴西秘魯3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm"
        //       },
        //       {
        //         title: "阿根廷巴西秘魯3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/1aKmArk37"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PE: [
        //       {
        //         title: "秘魯 單國套餐",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/4aA063ZBk"
        //       },
        //       {
        //         title: "秘魯 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/QVlaevrpR"
        //       },
        //       {
        //         title: "阿根廷巴西秘魯3國500MB",
        //         price: "NTD 129",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm"
        //       },
        //       {
        //         title: "阿根廷巴西秘魯3國1GB",
        //         price: "NTD 249",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/1aKmArk37"
        //       }
        //     ],
        //     CO: [
        //       {
        //         title: "哥倫比亞 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/796Dm9O3V"
        //       },
        //       {
        //         title: "哥倫比亞 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/QVladv3eo"
        //       }
        //     ],
        //     UY: [
        //       {
        //         title: "烏拉圭 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/LL3a6LELv"
        //       },
        //       {
        //         title: "烏拉圭 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/nVG1PmDDm"
        //       }
        //     ],
        //     VE: [
        //       {
        //         title: "委內瑞拉 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/6bZXmXdm7"
        //       },
        //       {
        //         title: "委內瑞拉 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/ZENYQP5VB"
        //       }
        //     ],
        //     GY: [
        //       {
        //         title: "圭亞那 單國套餐",
        //         price: "NTD 159",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/okODLkaDe"
        //       },
        //       {
        //         title: "圭亞那 單國套餐",
        //         price: "NTD 309",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/9KXv9JQEr"
        //       }
        //     ],
        //     PA: [
        //       {
        //         title: "巴拿馬 單國套餐",
        //         price: "NTD 219",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/gmPz4DpMo"
        //       },
        //       {
        //         title: "巴拿馬 單國套餐",
        //         price: "NTD 399",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/wG5mnXeO3"
        //       }
        //     ],
        //     CL: [
        //       {
        //         title: "智利 單國套餐",
        //         price: "NTD 249",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/RLDm4L91P"
        //       },
        //       {
        //         title: "智利 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/829am6m8P"
        //       },
        //       {
        //         title: "全球82國10GB",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BO: [
        //       {
        //         title: "玻利維亞 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/YmKYAmmD4"
        //       },
        //       {
        //         title: "玻利維亞 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/brmRvaJ6m"
        //       }
        //     ],
        //     CR: [
        //       {
        //         title: "哥斯大黎加 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/0opLB05wA"
        //       },
        //       {
        //         title: "哥斯大黎加 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/ynl8wb5vg"
        //       }
        //     ],
        //     SR: [
        //       {
        //         title: "蘇利南 單國套餐",
        //         price: "NTD 339",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/KbEmRb9pd"
        //       },
        //       {
        //         title: "蘇利南 單國套餐",
        //         price: "NTD 579",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/PVMZLGlOR"
        //       }
        //     ],
        //     EC: [
        //       {
        //         title: "厄瓜多爾 單國套餐",
        //         price: "NTD 369",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/aNXYkNl3v"
        //       },
        //       {
        //         title: "厄瓜多爾 單國套餐",
        //         price: "NTD 609",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/wG5mnXzMV"
        //       }
        //     ],
        //     DO: [
        //       {
        //         title: "多明尼加共和國 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ZENYQE5L4"
        //       },
        //       {
        //         title: "多明尼加共和國 單國套餐",
        //         price: "NTD 789",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/wG5m4XBbg"
        //       }
        //     ],
        //     GT: [
        //       {
        //         title: "瓜地馬拉 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/3badobL8Q"
        //       },
        //       {
        //         title: "瓜地馬拉 單國套餐",
        //         price: "NTD 789",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/796Dm3N2m"
        //       }
        //     ],
        //     NI: [
        //       {
        //         title: "尼加拉瓜 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/ZENYDM1B4"
        //       },
        //       {
        //         title: "尼加拉瓜 單國套餐",
        //         price: "NTD 789",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/RLDm4bpvr"
        //       }
        //     ],
        //     SV: [
        //       {
        //         title: "薩爾瓦多 單國套餐",
        //         price: "NTD 459",
        //         labels: ["1天", "500MB"],
        //         url: "https://dl.gl/zeD9YekLn"
        //       },
        //       {
        //         title: "薩爾瓦多 單國套餐",
        //         price: "NTD 789",
        //         labels: ["1天", "1GB"],
        //         url: "https://dl.gl/1aKm1G9VO"
        //       }
        //     ]
        //   },
        //   en: {
        //     GLOBAL: [
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     JP: [
        //       {
        //         title: "Japan  package",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/1aKma2Y9O"
        //       },
        //       {
        //         title: "Japan, Korea Unlimited package",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/BpyALBbgk"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     KR: [
        //       {
        //         title: "Korea  package",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/LL3a6LmlN"
        //       },
        //       {
        //         title: "Japan, Korea Unlimited package",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/BpyALBbgk"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CN: [
        //       {
        //         title: "China package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8R8ZdZ"
        //       },
        //       {
        //         title: "China package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a8mXJv"
        //       },
        //       {
        //         title: "China Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlinited"],
        //         url: "https://dl.gl/aNXYk4XaQ"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "China, Russia 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8wmB4L"
        //       },
        //       {
        //         title: "China, Russia 1GB package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYkeXZQ"
        //       },
        //       {
        //         title: "China, Russia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/Oo5LRvOzL"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     HK: [
        //       {
        //         title: "Hong Kong package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQYK72"
        //       },
        //       {
        //         title: "Hong Kong package",
        //         price: "NTD 139",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/1aKmAaOk6"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MO: [
        //       {
        //         title: "Macao package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1P1zwL"
        //       },
        //       {
        //         title: "Macao package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7o7DDB"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SG: [
        //       {
        //         title: "Singapore package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVlaVBe4Q"
        //       },
        //       {
        //         title: "Singapore Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/pVnA1Vp8l"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MY: [
        //       {
        //         title: "Malaysia package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/dRo6O6Xwy"
        //       },
        //       {
        //         title: "Malaysia Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day ", "Unlimited"],
        //         url: "https://dl.gl/LL3a6LBvv"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TH: [
        //       {
        //         title: "Thailand package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRzJkN7"
        //       },
        //       {
        //         title: "Thailand Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/vmb1OmzMl"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     VN: [
        //       {
        //         title: "Vietnam package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/RLDm4Lr6J"
        //       },
        //       {
        //         title: "Vietnam Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/ZENYQYgl9"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited package",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited data"],
        //         url: "https://dl.gl/J4w6YG1KD"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     ID: [
        //       {
        //         title: "Indonesia package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8R8Eml"
        //       },
        //       {
        //         title: "Indonesia package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28R4l0z"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PH: [
        //       {
        //         title: "Philippines package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/VY8m4mvka"
        //       },
        //       {
        //         title: "Philippines package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8w8AoL"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     KH: [
        //       {
        //         title: "Cambodia package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/wG5mPDRQz"
        //       },
        //       {
        //         title: "Cambodia package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZX1BaBy"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LA: [
        //       {
        //         title: "Laos package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPXaYB"
        //       },
        //       {
        //         title: "Laos package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RK9rl"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MM: [
        //       {
        //         title: "Myanmar package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvR0Pp"
        //       },
        //       {
        //         title: "Myanmar package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladVRJo"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IN: [
        //       {
        //         title: "India package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/796DmD7KD"
        //       },
        //       {
        //         title: "India package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RKY51"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IL: [
        //       {
        //         title: "Israel package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9vEZ1"
        //       },
        //       {
        //         title: "Israel package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmbGJy"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BD: [
        //       {
        //         title: "Bangladesh package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/kLgMbMlnY"
        //       },
        //       {
        //         title: "Bangladesh package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0rrKO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LK: [
        //       {
        //         title: "Sri Lanka package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/dRo6O6pGZ"
        //       },
        //       {
        //         title: "Sri Lanka package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/RLDm4Lkwn"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NP: [
        //       {
        //         title: "Nepal package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/2rNd0d5X4"
        //       },
        //       {
        //         title: "Nepal package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXgYkEa"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     JO: [
        //       {
        //         title: "Jordan package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladazp0"
        //       },
        //       {
        //         title: "Jordan package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6Y4nMG"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MN: [
        //       {
        //         title: "Mongolia package",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Epz8L8BQJ"
        //       },
        //       {
        //         title: "Mongolia package",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/dRo6OR6BY"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     QA: [
        //       {
        //         title: "Qatar package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Oo5LRLMM8"
        //       },
        //       {
        //         title: "Qatar package",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zaZ5y"
        //       }
        //     ],
        //     SA: [
        //       {
        //         title: "Saudi Arabia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/4aA0z0MJK"
        //       },
        //       {
        //         title: "Saudi Arabia package",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6LpM5"
        //       }
        //     ],
        //     BN: [
        //       {
        //         title: "Brunei package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/4aA0z04Yz"
        //       },
        //       {
        //         title: "Brunei package",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladV2BR"
        //       }
        //     ],
        //     MV: [
        //       {
        //         title: "Maldives package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6Y6aBp"
        //       },
        //       {
        //         title: "Maldives package",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladVG00"
        //       }
        //     ],
        //     BH: [
        //       {
        //         title: "Bahrain package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/BpyALAp5K"
        //       },
        //       {
        //         title: "Bahrain package",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oQgYl"
        //       }
        //     ],
        //     PK: [
        //       {
        //         title: "Pakistan package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpLpmbZ"
        //       },
        //       {
        //         title: "Pakistan package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/kLgMbL8p3"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     KZ: [
        //       {
        //         title: "Kazakhstan package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/5Qd7oQRYa"
        //       },
        //       {
        //         title: "Kazakhstan package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zarrZ"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AE: [
        //       {
        //         title: "UAE package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnA1Vklw"
        //       },
        //       {
        //         title: "UAE package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6Y4GKa"
        //       }
        //     ],
        //     AZ: [
        //       {
        //         title: "Azerbaijan package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/2rNd0apre"
        //       },
        //       {
        //         title: "Azerbaijan package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmbbNy"
        //       }
        //     ],
        //     AM: [
        //       {
        //         title: "Armenia package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1PV28J"
        //       },
        //       {
        //         title: "Armenia package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Nlb8R47ze"
        //       }
        //     ],
        //     GE: [
        //       {
        //         title: "Georgia package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9EeAG2"
        //       },
        //       {
        //         title: "Georgia package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OmLwK"
        //       }
        //     ],
        //     OM: [
        //       {
        //         title: "Oman package",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8wno6l"
        //       },
        //       {
        //         title: "Oman package",
        //         price: "NTD 339",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8La50v"
        //       }
        //     ],
        //     KW: [
        //       {
        //         title: "Kuwait package",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPlMok"
        //       },
        //       {
        //         title: "Kuwait package",
        //         price: "NTD 339",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1P8GBJ"
        //       }
        //     ],
        //     TJ: [
        //       {
        //         title: "Tajikistan package",
        //         price: "NTD 279",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/aNXYkNpPk"
        //       },
        //       {
        //         title: "Tajikistan package",
        //         price: "NTD 459",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0OmQO"
        //       }
        //     ],
        //     AT: [
        //       {
        //         title: "Austria package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/0opLBL3bp"
        //       },
        //       {
        //         title: "Austria package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/PVMZLvwKB"
        //       },
        //       {
        //         title: "Austria Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6Yv0LD"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BG: [
        //       {
        //         title: "Bulgaria package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpLpozR"
        //       },
        //       {
        //         title: "Bulgaria package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "ttps://dl.gl/nVG1P85B4"
        //       },
        //       {
        //         title: "Bulgaria Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/9KXv9oEB1"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CH: [
        //       {
        //         title: "Switzerland package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnA1AQ1l"
        //       },
        //       {
        //         title: "Switzerland package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/RLDm49DAm"
        //       },
        //       {
        //         title: "Switzerland Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/YmKYAB8lB"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CZ: [
        //       {
        //         title: "Czech Republic package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/PVMZLZkmO"
        //       },
        //       {
        //         title: "Czech Republic package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zd9l8"
        //       },
        //       {
        //         title: "Czech Republic Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/kLgMbR9zQ"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     DE: [
        //       {
        //         title: "Germany package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/vmb1O18gY"
        //       },
        //       {
        //         title: "Germany package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6KN0M"
        //       },
        //       {
        //         title: "Germany Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/RLDm49KRn"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     DK: [
        //       {
        //         title: "Denmark package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/829ama3eE"
        //       },
        //       {
        //         title: "Denmark package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7o0yOG"
        //       },
        //       {
        //         title: "Denmark Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/1aKmAGVwr"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     EE: [
        //       {
        //         title: "Estonia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/rRw1APLK5"
        //       },
        //       {
        //         title: "Estonia package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXPm2Gr"
        //       },
        //       {
        //         title: "Estonia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/KbEmRmKyp"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     ES: [
        //       {
        //         title: "Spain package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPzwzKNz"
        //       },
        //       {
        //         title: "Spain package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/gmPzwN69l"
        //       },
        //       {
        //         title: "Spain Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/KbEmRv81Y"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     FI: [
        //       {
        //         title: "Finland package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/829amaywO"
        //       },
        //       {
        //         title: "Finland package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRvyBXm"
        //       },
        //       {
        //         title: "Finland Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/5Qd7oZkAa"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     FR: [
        //       {
        //         title: "France package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvRNYK"
        //       },
        //       {
        //         title: "France package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0O2JJ"
        //       },
        //       {
        //         title: "France Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/llLXV0KmO"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     GB: [
        //       {
        //         title: "United Kingdom package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9E9N7O"
        //       },
        //       {
        //         title: "United Kingdom package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0O8A1"
        //       },
        //       {
        //         title: "United Kingdom Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/3badobXA0"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     HR: [
        //       {
        //         title: "Croatia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8w8Dy6"
        //       },
        //       {
        //         title: "Croatia package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6982yp"
        //       },
        //       {
        //         title: "Croatia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/QVla3Z2MX"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IE: [
        //       {
        //         title: "Ireland package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/vmb1O1zY2"
        //       },
        //       {
        //         title: "Ireland package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/YmKYABZpV"
        //       },
        //       {
        //         title: "Ireland Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/e8r2n1oDZ"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IS: [
        //       {
        //         title: "Iceland package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladZRNQ"
        //       },
        //       {
        //         title: "Iceland package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/pVnA1PrBO"
        //       },
        //       {
        //         title: "Iceland Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/wG5mnAZ6V"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IT: [
        //       {
        //         title: "Italy package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAmk2g"
        //       },
        //       {
        //         title: "Italy package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/e8r2n1N19"
        //       },
        //       {
        //         title: "Italy Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/gmPzwDgvD"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LV: [
        //       {
        //         title: "Latvia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/LL3a6aO4m"
        //       },
        //       {
        //         title: "Latvia package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8wbR3l"
        //       },
        //       {
        //         title: "Latvia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/PVMZLGRzL"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MT: [
        //       {
        //         title: "Malta package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/BpyAlm9G6"
        //       },
        //       {
        //         title: "Malta package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Nlb8R4mbb"
        //       },
        //       {
        //         title: "Malta Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/kLgMbR433"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NO: [
        //       {
        //         title: "Norway package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8w84LB"
        //       },
        //       {
        //         title: "Norway package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/rRw1KRovY"
        //       },
        //       {
        //         title: "Norway Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/KbEmRvgve"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PL: [
        //       {
        //         title: "Poland package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/5Qd7o75Ma"
        //       },
        //       {
        //         title: "Poland package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmdblp"
        //       },
        //       {
        //         title: "Poland Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/e8r2n1arw"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PT: [
        //       {
        //         title: "Portugal package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2n2BBb"
        //       },
        //       {
        //         title: "Portugal package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7o0DV7"
        //       },
        //       {
        //         title: "Portugal Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/pVnA1P8bQ"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     RO: [
        //       {
        //         title: "Romania package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/5Qd7p2bz5"
        //       },
        //       {
        //         title: "Romania package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28ReK0g"
        //       },
        //       {
        //         title: "Romania Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/kLgMbRZ07"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     RU: [
        //       {
        //         title: "Russia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmXvAD"
        //       },
        //       {
        //         title: "Russia package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6YGK6Z"
        //       },
        //       {
        //         title: "Russia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/brmRvy3Yr"
        //       },
        //       {
        //         title: "China, Russia 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8wmB4L"
        //       },
        //       {
        //         title: "China, Russia 1GB package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYkeXZQ"
        //       },
        //       {
        //         title: "China, Russia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/Oo5LRvOzL"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SE: [
        //       {
        //         title: "Sweden package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXm79GQ"
        //       },
        //       {
        //         title: "Sweden package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badonp4p"
        //       },
        //       {
        //         title: "Sweden Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/aNXYnGplv"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SI: [
        //       {
        //         title: "Slovenia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9v1w8"
        //       },
        //       {
        //         title: "Slovenia package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRMzKLX"
        //       },
        //       {
        //         title: "Slovenia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/wG5mnAZAN"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SK: [
        //       {
        //         title: "Slovakia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmX89X"
        //       },
        //       {
        //         title: "Slovakia package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnArBG"
        //       },
        //       {
        //         title: "Slovakia Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/RLDm2BYg4"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TR: [
        //       {
        //         title: "Turkey package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAmvwv"
        //       },
        //       {
        //         title: "Turkey package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Oo5LR9RdL"
        //       },
        //       {
        //         title: "Turkey Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/llLXPRkPE"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     UA: [
        //       {
        //         title: "Ukraine package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvRdQ8"
        //       },
        //       {
        //         title: "Ukraine package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRL02yX"
        //       },
        //       {
        //         title: "Ukraine Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/aNXYnkZw1"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LI: [
        //       {
        //         title: "Liechtenstein package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladaNZl"
        //       },
        //       {
        //         title: "Liechtenstein package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmAGO9v"
        //       },
        //       {
        //         title: "Liechtenstein Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/XvpYJokmO"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     VA: [
        //       {
        //         title: "Vatican package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPzwz5Dz"
        //       },
        //       {
        //         title: "Vatican package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badono70"
        //       },
        //       {
        //         title: "Vatican Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/3badonPym"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MC: [
        //       {
        //         title: "Monaco package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPX7Pr"
        //       },
        //       {
        //         title: "Monaco package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYk4Dov"
        //       },
        //       {
        //         title: "Monaco Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/vmb1OLavG"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AX: [
        //       {
        //         title: "Åland Islands package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/aNXYkYmrQ"
        //       },
        //       {
        //         title: "Åland Islands package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/e8r2n1k59"
        //       },
        //       {
        //         title: "Åland Islands Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/4aA0RQZ58"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     SM: [
        //       {
        //         title: "San Marino package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvR298"
        //       },
        //       {
        //         title: "San Marino package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/BpyALmXJm"
        //       },
        //       {
        //         title: "San Marino Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/LL3aO9dZg"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NL: [
        //       {
        //         title: "Netherlands package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/m1zLMLOp9"
        //       },
        //       {
        //         title: "Netherlands package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6KBym"
        //       },
        //       {
        //         title: "Netherlands Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/3badoneG0"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BE: [
        //       {
        //         title: "Belgium package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAmA0Z"
        //       },
        //       {
        //         title: "Belgium package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8wG2a6"
        //       },
        //       {
        //         title: "Belgium Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/brmRvy9rr"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LU: [
        //       {
        //         title: "Luxembourg package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPXy7o"
        //       },
        //       {
        //         title: "Luxembourg package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/m1zLkYEJ9"
        //       },
        //       {
        //         title: "Luxembourg Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/QVladOgPk"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited package",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CY: [
        //       {
        //         title: "Cyprus package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/wG5mnmyrg"
        //       },
        //       {
        //         title: "Cyprus package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zdLEN"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     GR: [
        //       {
        //         title: "Greece package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQY8KN"
        //       },
        //       {
        //         title: "Greece package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OLm0G"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     HU: [
        //       {
        //         title: "Hungary package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/kLgMbMplQ"
        //       },
        //       {
        //         title: "Hungary package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJeOVD"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     LT: [
        //       {
        //         title: "Lithuania package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Epz8L8nYw"
        //       },
        //       {
        //         title: "Lithuania package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRvamV0"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     RS: [
        //       {
        //         title: "Serbia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRME8ZK"
        //       },
        //       {
        //         title: "Serbia package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/VY8m4P8Ja"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     ME: [
        //       {
        //         title: "Montenegro package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRLREPX"
        //       },
        //       {
        //         title: "Montenegro package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/kLgMbY9m1"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     GG: [
        //       {
        //         title: "Guernsey package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8R8OmO"
        //       },
        //       {
        //         title: "Guernsey package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYkRPVZ"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     JE: [
        //       {
        //         title: "Jersey package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/rRw1A1A4L"
        //       },
        //       {
        //         title: "Jersey package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1PmwrY"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     IM: [
        //       {
        //         title: "Isle of man package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQY8Jv"
        //       },
        //       {
        //         title: "Isle of man package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/829am699Y"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BA: [
        //       {
        //         title: "Bosnia and Herzegovina package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAebLv"
        //       },
        //       {
        //         title: "Bosnia and Herzegovina package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badoQzKp"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     GI: [
        //       {
        //         title: "Gibraltar package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEMap"
        //       },
        //       {
        //         title: "Gibraltar package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/829am67K2"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     AL: [
        //       {
        //         title: "Albania package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/XvpYJvZkQ"
        //       },
        //       {
        //         title: "Albania package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8Ll28g"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MK: [
        //       {
        //         title: "Macedonia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/LL3a6Llb7"
        //       },
        //       {
        //         title: "Macedonia package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8LlPgy"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e"
        //       }
        //     ],
        //     EG: [
        //       {
        //         title: "Egypt package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badodnzQ"
        //       },
        //       {
        //         title: "Egypt package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXP6ayo"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MA: [
        //       {
        //         title: "Morocco package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/kLgMbML81"
        //       },
        //       {
        //         title: "Morocco package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArwGO"
        //       }
        //     ],
        //     KE: [
        //       {
        //         title: "Kenya package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladVBJ0"
        //       },
        //       {
        //         title: "Kenya package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Oo5LRvDN8"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     EH: [
        //       {
        //         title: "Western Sahara package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/okODLkVNJ"
        //       },
        //       {
        //         title: "Western Sahara package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/G4OpLmkRM"
        //       }
        //     ],
        //     GH: [
        //       {
        //         title: "Ghana package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4Op8NR6M"
        //       },
        //       {
        //         title: "Ghana package",
        //         price: "NTD 369",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/BpyALdk71"
        //       }
        //     ],
        //     ZA: [
        //       {
        //         title: "South Africa package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/796Dm9l5D"
        //       },
        //       {
        //         title: "South Africa package",
        //         price: "NTD 369",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/e8r2nMJ8v"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MG: [
        //       {
        //         title: "Madagascar package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badobwop"
        //       },
        //       {
        //         title: "Madagascar package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXVVz"
        //       }
        //     ],
        //     DZ: [
        //       {
        //         title: "Algeria package",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/dRo6ORVX1"
        //       },
        //       {
        //         title: "Algeria package",
        //         price: "NTD 399",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/dRo6ONAeV"
        //       }
        //     ],
        //     ZM: [
        //       {
        //         title: "Zambia package",
        //         price: "NTD 249",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvr4Qw"
        //       },
        //       {
        //         title: "Zambia package",
        //         price: "NTD 429",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmdBLm"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MU: [
        //       {
        //         title: "Mauritius package",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpL4mnZ"
        //       },
        //       {
        //         title: "Mauritius package",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6vgbz"
        //       }
        //     ],
        //     NG: [
        //       {
        //         title: "Nigeria package",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badobA01"
        //       },
        //       {
        //         title: "Nigeria package",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oAOK7"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TN: [
        //       {
        //         title: "Tunisia package",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpL4ezZ"
        //       },
        //       {
        //         title: "Tunisia package",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6YGEzZ"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     TZ: [
        //       {
        //         title: "Tanzania package",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9EePB2"
        //       },
        //       {
        //         title: "Tanzania package",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJenOK"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AO: [
        //       {
        //         title: "Angola package",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2n8YEk"
        //       },
        //       {
        //         title: "Angola package",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/zeD9E5z43"
        //       }
        //     ],
        //     AU: [
        //       {
        //         title: "Australia package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPzwzzKD"
        //       },
        //       {
        //         title: "Australia package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRva6Vn"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLme9G"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     NZ: [
        //       {
        //         title: "New Zealand package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPX55g"
        //       },
        //       {
        //         title: "New Zealand package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/gmPzwYZ8w"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLme9G"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     FJ: [
        //       {
        //         title: "Fiji package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9vKQ4"
        //       },
        //       {
        //         title: "Fiji package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/PVMZP7Va9"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLme9G"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     GU: [
        //       {
        //         title: "Guam package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/YmKYAYaNP"
        //       },
        //       {
        //         title: "Guam package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLmemw"
        //       },
        //       {
        //         title: "Guam, Saipan 500MB package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoQZNY"
        //       },
        //       {
        //         title: "Guam, Saipan 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oAMnZ"
        //       }
        //     ],
        //     MP: [
        //       {
        //         title: "Saipan package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvrX9w"
        //       },
        //       {
        //         title: "Saipan package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJe9LP"
        //       },
        //       {
        //         title: "Guam, Saipan 500MB package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoQZNY"
        //       },
        //       {
        //         title: "Guam, Saipan 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oAMnZ"
        //       }
        //     ],
        //     US: [
        //       {
        //         title: "United States package",
        //         price: "NTD 99",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvRnLK"
        //       },
        //       {
        //         title: "United States package",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8LlJJy"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     CA: [
        //       {
        //         title: "Canada package",
        //         price: "NTD 110",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2n2951"
        //       },
        //       {
        //         title: "Canada package",
        //         price: "NTD 215",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OdJ7Q"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     MX: [
        //       {
        //         title: "Mexico package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9vvlM"
        //       },
        //       {
        //         title: "Mexico package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28ReQm1"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PR: [
        //       {
        //         title: "Puerto Rico package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/PVMZLGYz2"
        //       },
        //       {
        //         title: "Puerto Rico package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zewgK"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     GP: [
        //       {
        //         title: "Guadeloupe package",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/KbEmRmzwa"
        //       },
        //       {
        //         title: "Guadeloupe package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1Pm4lY"
        //       }
        //     ],
        //     MF: [
        //       {
        //         title: "Saint Martin package",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/PVMZPaKLZ"
        //       },
        //       {
        //         title: "Saint Martin package",
        //         price: "NTD 339",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OLKO2"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AG: [
        //       {
        //         title: "Antigua and Barbuda package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1PVKXe"
        //       },
        //       {
        //         title: "Antigua and Barbuda package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1PmbYb"
        //       }
        //     ],
        //     AW: [
        //       {
        //         title: "Aruba package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvrv4r"
        //       },
        //       {
        //         title: "Aruba package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmdJB7"
        //       }
        //     ],
        //     KY: [
        //       {
        //         title: "Cayman Islands package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/wG5mnG6O5"
        //       },
        //       {
        //         title: "Cayman Islands package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/0opLBXKOA"
        //       }
        //     ],
        //     CW: [
        //       {
        //         title: "Curacao package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladVGyo"
        //       },
        //       {
        //         title: "Curacao package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/796Dm3NkN"
        //       }
        //     ],
        //     GD: [
        //       {
        //         title: "Grenada package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8Rl8Gv"
        //       },
        //       {
        //         title: "Grenada package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXPmD4O"
        //       }
        //     ],
        //     HT: [
        //       {
        //         title: "Haiti package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/829am2oln"
        //       },
        //       {
        //         title: "Haiti package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/pVnA1X4lQ"
        //       }
        //     ],
        //     JM: [
        //       {
        //         title: "Jamaica package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnA1VB4w"
        //       },
        //       {
        //         title: "Jamaica package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXayz"
        //       }
        //     ],
        //     TT: [
        //       {
        //         title: "Trinidad and Tobago package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnAvl5X4"
        //       },
        //       {
        //         title: "Trinidad and Tobago package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badoQZK1"
        //       }
        //     ],
        //     TC: [
        //       {
        //         title: "Turks and Caicos Islands package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1PVBDm"
        //       },
        //       {
        //         title: "Turks and Caicos Islands package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0KnkR"
        //       }
        //     ],
        //     MQ: [
        //       {
        //         title: "Martinique package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQEmJB"
        //       },
        //       {
        //         title: "Martinique package",
        //         price: "NTD 699",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/G4OpLml0R"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     AI: [
        //       {
        //         title: "Anguilla package",
        //         price: "NTD 489",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/KbEmRb3NL"
        //       },
        //       {
        //         title: "Anguilla package",
        //         price: "NTD 819",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ZENYQP4y1"
        //       }
        //     ],
        //     VG: [
        //       {
        //         title: "British Virgin Islands package",
        //         price: "NTD 489",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmb0m8"
        //       },
        //       {
        //         title: "British Virgin Islands package",
        //         price: "NTD 819",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oA1vl"
        //       }
        //     ],
        //     VC: [
        //       {
        //         title: "Saint Vincent and the Grenadines package",
        //         price: "NTD 489",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRLA573"
        //       },
        //       {
        //         title: "Saint Vincent and the Grenadines package",
        //         price: "NTD 819",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1Pmgpe"
        //       }
        //     ],
        //     AR: [
        //       {
        //         title: "Argentina package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Epz8L8dgL"
        //       },
        //       {
        //         title: "Argentina package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/DKLB0MXZV"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArk37"
        //       }
        //     ],
        //     BR: [
        //       {
        //         title: "Brazil package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/YmKYe301n"
        //       },
        //       {
        //         title: "Brazil package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJa4MK"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArk37"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     PE: [
        //       {
        //         title: "Peru  package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/4aA063ZBk"
        //       },
        //       {
        //         title: "Peru  package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVlaevrpR"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 500MB package",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 1GB package",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArk37"
        //       }
        //     ],
        //     CO: [
        //       {
        //         title: "Colombia package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/796Dm9O3V"
        //       },
        //       {
        //         title: "Colombia package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladv3eo"
        //       }
        //     ],
        //     UY: [
        //       {
        //         title: "Uruguay package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/LL3a6LELv"
        //       },
        //       {
        //         title: "Uruguay package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1PmDDm"
        //       }
        //     ],
        //     VE: [
        //       {
        //         title: "Venezuela package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmXdm7"
        //       },
        //       {
        //         title: "Venezuela package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ZENYQP5VB"
        //       }
        //     ],
        //     GY: [
        //       {
        //         title: "Guyana package",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/okODLkaDe"
        //       },
        //       {
        //         title: "Guyana package",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/9KXv9JQEr"
        //       }
        //     ],
        //     PA: [
        //       {
        //         title: "Panama package",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPz4DpMo"
        //       },
        //       {
        //         title: "Panama package",
        //         price: "NTD 399",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXeO3"
        //       }
        //     ],
        //     CL: [
        //       {
        //         title: "Chile package",
        //         price: "NTD 249",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/RLDm4L91P"
        //       },
        //       {
        //         title: "Chile package",
        //         price: "NTD 459",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/829am6m8P"
        //       },
        //       {
        //         title: "Global 82 countries 10GB package",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V"
        //       }
        //     ],
        //     BO: [
        //       {
        //         title: "Bolivia package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/YmKYAmmD4"
        //       },
        //       {
        //         title: "Bolivia package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRvaJ6m"
        //       }
        //     ],
        //     CR: [
        //       {
        //         title: "Costa Rica package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/0opLB05wA"
        //       },
        //       {
        //         title: "Costa Rica package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8wb5vg"
        //       }
        //     ],
        //     SR: [
        //       {
        //         title: "Suriname package",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/KbEmRb9pd"
        //       },
        //       {
        //         title: "Suriname package",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/PVMZLGlOR"
        //       }
        //     ],
        //     EC: [
        //       {
        //         title: "Ecuador package",
        //         price: "NTD 369",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/aNXYkNl3v"
        //       },
        //       {
        //         title: "Ecuador package",
        //         price: "NTD 609",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXzMV"
        //       }
        //     ],
        //     DO: [
        //       {
        //         title: "The Dominican Republic package",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQE5L4"
        //       },
        //       {
        //         title: "The Dominican Republic package",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5m4XBbg"
        //       }
        //     ],
        //     GT: [
        //       {
        //         title: "Guatemala package",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badobL8Q"
        //       },
        //       {
        //         title: "Guatemala package",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/796Dm3N2m"
        //       }
        //     ],
        //     NI: [
        //       {
        //         title: "Nicaragua package",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYDM1B4"
        //       },
        //       {
        //         title: "Nicaragua package",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/RLDm4bpvr"
        //       }
        //     ],
        //     SV: [
        //       {
        //         title: "El Salvador package",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9YekLn"
        //       },
        //       {
        //         title: "El Salvador package",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKm1G9VO"
        //       }
        //     ]
        //   },
        //   ja: {
        //     GLOBAL: [
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     JP: [
        //       {
        //         title: "日本 Unlimited プラン",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/1aKma2Y9O",
        //         code: "Japan"
        //       },
        //       {
        //         title: "Japan, Korea Unlimited プラン",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/BpyALBbgk",
        //         code: "Japan, Korea"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     KR: [
        //       {
        //         title: "韓国 Unlimited プラン",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/LL3a6LmlN",
        //         code: "Korea"
        //       },
        //       {
        //         title: "Japan, Korea Unlimited プラン",
        //         price: "NTD 69",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/BpyALBbgk",
        //         code: "Japan, Korea"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     CN: [
        //       {
        //         title: "中国 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8R8ZdZ",
        //         code: "China"
        //       },
        //       {
        //         title: "中国 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a8mXJv",
        //         code: "China"
        //       },
        //       {
        //         title: "中国 Unlinited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlinited"],
        //         url: "https://dl.gl/aNXYk4XaQ",
        //         code: "China"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast asia 6 countries"
        //       },
        //       {
        //         title: "China, Russia 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8wmB4L",
        //         code: "China, Russia"
        //       },
        //       {
        //         title: "China, Russia 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYkeXZQ",
        //         code: "China, Russia"
        //       },
        //       {
        //         title: "China, Russia Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/Oo5LRvOzL",
        //         code: "China, Russia"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     HK: [
        //       {
        //         title: "香港 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQYK72",
        //         code: "Hong Kong"
        //       },
        //       {
        //         title: "香港 Unlimited プラン",
        //         price: "NTD 139",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/1aKmAaOk6",
        //         code: "Hong Kong"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MO: [
        //       {
        //         title: "マカオ 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1P1zwL",
        //         code: "Macao"
        //       },
        //       {
        //         title: "マカオ 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7o7DDB",
        //         code: "Macao"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     SG: [
        //       {
        //         title: "シンガポール 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVlaVBe4Q",
        //         code: "Singapore"
        //       },
        //       {
        //         title: "シンガポール Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/pVnA1Vp8l",
        //         code: "Singapore"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast asia 10 countries"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6YG1KD",
        //         code: "SG MY TH VN"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MY: [
        //       {
        //         title: "マレーシア 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/dRo6O6Xwy",
        //         code: "Malaysia"
        //       },
        //       {
        //         title: "マレーシア Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day ", "Unlimited"],
        //         url: "https://dl.gl/LL3a6LBvv",
        //         code: "Malaysia"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast asia 10 countries"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6YG1KD",
        //         code: "SG MY TH VN"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     TH: [
        //       {
        //         title: "タイ 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRzJkN7",
        //         code: "Thailand"
        //       },
        //       {
        //         title: "タイ Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/vmb1OmzMl",
        //         code: "Thailand"
        //       },
        //       {
        //         title: "China, Southeast asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast asia 10 countries"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6YG1KD",
        //         code: "SG MY TH VN"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     VN: [
        //       {
        //         title: "ベトナム 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/RLDm4Lr6J",
        //         code: "Vietnam"
        //       },
        //       {
        //         title: "ベトナム Unlimited プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/ZENYQYgl9",
        //         code: "Vietnam"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "SG MY TH VN Unlimited data プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "Unlimited data"],
        //         url: "https://dl.gl/J4w6YG1KD",
        //         code: "SG MY TH VN"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     ID: [
        //       {
        //         title: "インドネシア 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8R8Eml",
        //         code: "Indonesia"
        //       },
        //       {
        //         title: "インドネシア 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28R4l0z",
        //         code: "Indonesia"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast Asia 6 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     PH: [
        //       {
        //         title: "フィリピン 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/VY8m4mvka",
        //         code: "Philippines"
        //       },
        //       {
        //         title: "フィリピン 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8w8AoL",
        //         code: "Philippines"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast Asia 6 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     KH: [
        //       {
        //         title: "カンボジア 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/wG5mPDRQz",
        //         code: "Cambodia"
        //       },
        //       {
        //         title: "カンボジア 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZX1BaBy",
        //         code: "Cambodia"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast Asia 6 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     LA: [
        //       {
        //         title: "ラオス 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPXaYB",
        //         code: "Laos"
        //       },
        //       {
        //         title: "ラオス 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RK9rl",
        //         code: "Laos"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast Asia 6 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MM: [
        //       {
        //         title: "ミャンマー 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvR0Pp",
        //         code: "Myanmar"
        //       },
        //       {
        //         title: "ミャンマー 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladVRJo",
        //         code: "Myanmar"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast Asia 6 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     IN: [
        //       {
        //         title: "インド 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/796DmD7KD",
        //         code: "India"
        //       },
        //       {
        //         title: "インド 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RKY51",
        //         code: "India"
        //       },
        //       {
        //         title: "China, Southeast Asia 10 countries 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEB11",
        //         code: "China, Southeast Asia 10 countries"
        //       },
        //       {
        //         title: "China, Southeast Asia 6 countries 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28RerMl",
        //         code: "China, Southeast Asia 6 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     IL: [
        //       {
        //         title: "イスラエル 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9vEZ1",
        //         code: "Israel"
        //       },
        //       {
        //         title: "イスラエル 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmbGJy",
        //         code: "Israel"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     BD: [
        //       {
        //         title: "バングラデシュ 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/kLgMbMlnY",
        //         code: "Bangladesh"
        //       },
        //       {
        //         title: "バングラデシュ 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0rrKO",
        //         code: "Bangladesh"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     LK: [
        //       {
        //         title: "スリランカ 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/dRo6O6pGZ",
        //         code: "Sri Lanka"
        //       },
        //       {
        //         title: "スリランカ 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/RLDm4Lkwn",
        //         code: "Sri Lanka"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     NP: [
        //       {
        //         title: "ネパール 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/2rNd0d5X4",
        //         code: "Nepal"
        //       },
        //       {
        //         title: "ネパール 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXgYkEa",
        //         code: "Nepal"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     JO: [
        //       {
        //         title: "ヨルダン 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladazp0",
        //         code: "Jordan"
        //       },
        //       {
        //         title: "ヨルダン 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6Y4nMG",
        //         code: "Jordan"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MN: [
        //       {
        //         title: "モンゴル国 500MB プラン",
        //         price: "NTD 80",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Epz8L8BQJ",
        //         code: "Mongolia"
        //       },
        //       {
        //         title: "モンゴル国 1GB プラン",
        //         price: "NTD 155",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/dRo6OR6BY",
        //         code: "Mongolia"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     QA: [
        //       {
        //         title: "カタール 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Oo5LRLMM8",
        //         code: "Qatar"
        //       },
        //       {
        //         title: "カタール 1GB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zaZ5y",
        //         code: "Qatar"
        //       }
        //     ],
        //     SA: [
        //       {
        //         title: "サウジアラビア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/4aA0z0MJK",
        //         code: "Saudi Arabia"
        //       },
        //       {
        //         title: "サウジアラビア 1GB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6LpM5",
        //         code: "Saudi Arabia"
        //       }
        //     ],
        //     BN: [
        //       {
        //         title: "ブルネイ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/4aA0z04Yz",
        //         code: "Brunei"
        //       },
        //       {
        //         title: "ブルネイ 1GB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladV2BR",
        //         code: "Brunei"
        //       }
        //     ],
        //     MV: [
        //       {
        //         title: "モルディブ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6Y6aBp",
        //         code: "Maldives"
        //       },
        //       {
        //         title: "モルディブ 1GB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladVG00",
        //         code: "Maldives"
        //       }
        //     ],
        //     BH: [
        //       {
        //         title: "バーレーン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/BpyALAp5K",
        //         code: "Bahrain"
        //       },
        //       {
        //         title: "バーレーン 1GB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oQgYl",
        //         code: "Bahrain"
        //       }
        //     ],
        //     PK: [
        //       {
        //         title: "パキスタン 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpLpmbZ",
        //         code: "Pakistan"
        //       },
        //       {
        //         title: "パキスタン 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/kLgMbL8p3",
        //         code: "Pakistan"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     KZ: [
        //       {
        //         title: "カザフ 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/5Qd7oQRYa",
        //         code: "Kazakhstan"
        //       },
        //       {
        //         title: "カザフ 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zarrZ",
        //         code: "Kazakhstan"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     AE: [
        //       {
        //         title: "アラブ首長国連邦 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnA1Vklw",
        //         code: "UAE"
        //       },
        //       {
        //         title: "アラブ首長国連邦 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6Y4GKa",
        //         code: "UAE"
        //       }
        //     ],
        //     AZ: [
        //       {
        //         title: "アゼルバイジャン 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/2rNd0apre",
        //         code: "Azerbaijan"
        //       },
        //       {
        //         title: "アゼルバイジャン 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmbbNy",
        //         code: "Azerbaijan"
        //       }
        //     ],
        //     AM: [
        //       {
        //         title: "アルメニア 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1PV28J",
        //         code: "Armenia"
        //       },
        //       {
        //         title: "アルメニア 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Nlb8R47ze",
        //         code: "Armenia"
        //       }
        //     ],
        //     GE: [
        //       {
        //         title: "ジョージア 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9EeAG2",
        //         code: "Georgia"
        //       },
        //       {
        //         title: "ジョージア 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OmLwK",
        //         code: "Georgia"
        //       }
        //     ],
        //     OM: [
        //       {
        //         title: "オマーン 500MB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8wno6l",
        //         code: "Oman"
        //       },
        //       {
        //         title: "オマーン 1GB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8La50v",
        //         code: "Oman"
        //       }
        //     ],
        //     KW: [
        //       {
        //         title: "クウェート 500MB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPlMok",
        //         code: "Kuwait"
        //       },
        //       {
        //         title: "クウェート 1GB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1P8GBJ",
        //         code: "Kuwait"
        //       }
        //     ],
        //     TJ: [
        //       {
        //         title: "タジキスタン 500MB プラン",
        //         price: "NTD 279",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/aNXYkNpPk",
        //         code: "Tajikistan"
        //       },
        //       {
        //         title: "タジキスタン 1GB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0OmQO",
        //         code: "Tajikistan"
        //       }
        //     ],
        //     AT: [
        //       {
        //         title: "オーストリア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/0opLBL3bp",
        //         code: "Austria"
        //       },
        //       {
        //         title: "オーストリア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/PVMZLvwKB",
        //         code: "Austria"
        //       },
        //       {
        //         title: "オーストリア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/J4w6Yv0LD",
        //         code: "Austria"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     BG: [
        //       {
        //         title: "ブルガリア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpLpozR",
        //         code: "Bulgaria"
        //       },
        //       {
        //         title: "ブルガリア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "ttps://dl.gl/nVG1P85B4",
        //         code: "Bulgaria"
        //       },
        //       {
        //         title: "ブルガリア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/9KXv9oEB1",
        //         code: "Bulgaria"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     CH: [
        //       {
        //         title: "スイス 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnA1AQ1l",
        //         code: "Switzerland"
        //       },
        //       {
        //         title: "スイス 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/RLDm49DAm",
        //         code: "Switzerland"
        //       },
        //       {
        //         title: "スイス Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/YmKYAB8lB",
        //         code: "Switzerland"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     CZ: [
        //       {
        //         title: "チェコ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/PVMZLZkmO",
        //         code: "Czech Republic"
        //       },
        //       {
        //         title: "チェコ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zd9l8",
        //         code: "Czech Republic"
        //       },
        //       {
        //         title: "チェコ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/kLgMbR9zQ",
        //         code: "Czech Republic"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     DE: [
        //       {
        //         title: "ドイツ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/vmb1O18gY",
        //         code: "Germany"
        //       },
        //       {
        //         title: "ドイツ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6KN0M",
        //         code: "Germany"
        //       },
        //       {
        //         title: "ドイツ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/RLDm49KRn",
        //         code: "Germany"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     DK: [
        //       {
        //         title: "デンマーク 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/829ama3eE",
        //         code: "Denmark"
        //       },
        //       {
        //         title: "デンマーク 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7o0yOG",
        //         code: "Denmark"
        //       },
        //       {
        //         title: "デンマーク Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/1aKmAGVwr",
        //         code: "Denmark"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     EE: [
        //       {
        //         title: "エストニア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/rRw1APLK5",
        //         code: "Estonia"
        //       },
        //       {
        //         title: "エストニア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXPm2Gr",
        //         code: "Estonia"
        //       },
        //       {
        //         title: "エストニア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/KbEmRmKyp",
        //         code: "Estonia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     ES: [
        //       {
        //         title: "スペイン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPzwzKNz",
        //         code: "Spain"
        //       },
        //       {
        //         title: "スペイン 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/gmPzwN69l",
        //         code: "Spain"
        //       },
        //       {
        //         title: "スペイン Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/KbEmRv81Y",
        //         code: "Spain"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     FI: [
        //       {
        //         title: "フィンランド 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/829amaywO",
        //         code: "Finland"
        //       },
        //       {
        //         title: "フィンランド 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRvyBXm",
        //         code: "Finland"
        //       },
        //       {
        //         title: "フィンランド Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/5Qd7oZkAa",
        //         code: "Finland"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     FR: [
        //       {
        //         title: "フランス 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvRNYK",
        //         code: "France"
        //       },
        //       {
        //         title: "フランス 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0O2JJ",
        //         code: "France"
        //       },
        //       {
        //         title: "フランス Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/llLXV0KmO",
        //         code: "France"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     GB: [
        //       {
        //         title: "イギリス 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9E9N7O",
        //         code: "United Kingdom"
        //       },
        //       {
        //         title: "イギリス 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0O8A1",
        //         code: "United Kingdom"
        //       },
        //       {
        //         title: "イギリス Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/3badobXA0",
        //         code: "United Kingdom"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     HR: [
        //       {
        //         title: "クロアチア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8w8Dy6",
        //         code: "Croatia"
        //       },
        //       {
        //         title: "クロアチア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6982yp",
        //         code: "Croatia"
        //       },
        //       {
        //         title: "クロアチア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/QVla3Z2MX",
        //         code: "Croatia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     IE: [
        //       {
        //         title: "アイルランド 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/vmb1O1zY2",
        //         code: "Ireland"
        //       },
        //       {
        //         title: "アイルランド 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/YmKYABZpV",
        //         code: "Ireland"
        //       },
        //       {
        //         title: "アイルランド Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/e8r2n1oDZ",
        //         code: "Ireland"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     IS: [
        //       {
        //         title: "アイスランド 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladZRNQ",
        //         code: "Iceland"
        //       },
        //       {
        //         title: "アイスランド 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/pVnA1PrBO",
        //         code: "Iceland"
        //       },
        //       {
        //         title: "アイスランド Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/wG5mnAZ6V",
        //         code: "Iceland"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     IT: [
        //       {
        //         title: "イタリア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAmk2g",
        //         code: "Italy"
        //       },
        //       {
        //         title: "イタリア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/e8r2n1N19",
        //         code: "Italy"
        //       },
        //       {
        //         title: "イタリア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/gmPzwDgvD",
        //         code: "Italy"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     LV: [
        //       {
        //         title: "ラトビア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/LL3a6aO4m",
        //         code: "Latvia"
        //       },
        //       {
        //         title: "ラトビア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8wbR3l",
        //         code: "Latvia"
        //       },
        //       {
        //         title: "ラトビア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/PVMZLGRzL",
        //         code: "Latvia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MT: [
        //       {
        //         title: "マルタ共和国 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/BpyAlm9G6",
        //         code: "Malta"
        //       },
        //       {
        //         title: "マルタ共和国 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Nlb8R4mbb",
        //         code: "Malta"
        //       },
        //       {
        //         title: "マルタ共和国 Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/kLgMbR433",
        //         code: "Malta"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     NO: [
        //       {
        //         title: "ノルウェー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8w84LB",
        //         code: "Norway"
        //       },
        //       {
        //         title: "ノルウェー 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/rRw1KRovY",
        //         code: "Norway"
        //       },
        //       {
        //         title: "ノルウェー Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/KbEmRvgve",
        //         code: "Norway"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     PL: [
        //       {
        //         title: "ポーランド 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/5Qd7o75Ma",
        //         code: "Poland"
        //       },
        //       {
        //         title: "ポーランド 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmdblp",
        //         code: "Poland"
        //       },
        //       {
        //         title: "ポーランド Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/e8r2n1arw",
        //         code: "Poland"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     PT: [
        //       {
        //         title: "ポルトガル 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2n2BBb",
        //         code: "Portugal"
        //       },
        //       {
        //         title: "ポルトガル 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7o0DV7",
        //         code: "Portugal"
        //       },
        //       {
        //         title: "ポルトガル Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/pVnA1P8bQ",
        //         code: "Portugal"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     RO: [
        //       {
        //         title: "ルーマニア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/5Qd7p2bz5",
        //         code: "Romania"
        //       },
        //       {
        //         title: "ルーマニア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28ReK0g",
        //         code: "Romania"
        //       },
        //       {
        //         title: "ルーマニア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/kLgMbRZ07",
        //         code: "Romania"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     RU: [
        //       {
        //         title: "ロシア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmXvAD",
        //         code: "Russia"
        //       },
        //       {
        //         title: "ロシア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6YGK6Z",
        //         code: "Russia"
        //       },
        //       {
        //         title: "ロシア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/brmRvy3Yr",
        //         code: "Russia"
        //       },
        //       {
        //         title: "China, Russia 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ynl8wmB4L",
        //         code: "China, Russia"
        //       },
        //       {
        //         title: "China, Russia 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYkeXZQ",
        //         code: "China, Russia"
        //       },
        //       {
        //         title: "China, Russia Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/Oo5LRvOzL",
        //         code: "China, Russia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     SE: [
        //       {
        //         title: "スウェーデン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXm79GQ",
        //         code: "Sweden"
        //       },
        //       {
        //         title: "スウェーデン 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badonp4p",
        //         code: "Sweden"
        //       },
        //       {
        //         title: "スウェーデン Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/aNXYnGplv",
        //         code: "Sweden"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     SI: [
        //       {
        //         title: "スロベニア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9v1w8",
        //         code: "Slovenia"
        //       },
        //       {
        //         title: "スロベニア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRMzKLX",
        //         code: "Slovenia"
        //       },
        //       {
        //         title: "スロベニア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/wG5mnAZAN",
        //         code: "Slovenia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     SK: [
        //       {
        //         title: "スロバキア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmX89X",
        //         code: "Slovakia"
        //       },
        //       {
        //         title: "スロバキア 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnArBG",
        //         code: "Slovakia"
        //       },
        //       {
        //         title: "スロバキア Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/RLDm2BYg4",
        //         code: "Slovakia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     TR: [
        //       {
        //         title: "トルコ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAmvwv",
        //         code: "Turkey"
        //       },
        //       {
        //         title: "トルコ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Oo5LR9RdL",
        //         code: "Turkey"
        //       },
        //       {
        //         title: "トルコ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/llLXPRkPE",
        //         code: "Turkey"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     UA: [
        //       {
        //         title: "ウクライナ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvRdQ8",
        //         code: "Ukraine"
        //       },
        //       {
        //         title: "ウクライナ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRL02yX",
        //         code: "Ukraine"
        //       },
        //       {
        //         title: "ウクライナ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/aNXYnkZw1",
        //         code: "Ukraine"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     LI: [
        //       {
        //         title: "リヒテンシュタイン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladaNZl",
        //         code: "Liechtenstein"
        //       },
        //       {
        //         title: "リヒテンシュタイン 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmAGO9v",
        //         code: "Liechtenstein"
        //       },
        //       {
        //         title: "リヒテンシュタイン Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/XvpYJokmO",
        //         code: "Liechtenstein"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     VA: [
        //       {
        //         title: "バチカン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPzwz5Dz",
        //         code: "Vatican"
        //       },
        //       {
        //         title: "バチカン 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badono70",
        //         code: "Vatican"
        //       },
        //       {
        //         title: "バチカン Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/3badonPym",
        //         code: "Vatican"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MC: [
        //       {
        //         title: "モナコ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPX7Pr",
        //         code: "Monaco"
        //       },
        //       {
        //         title: "モナコ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYk4Dov",
        //         code: "Monaco"
        //       },
        //       {
        //         title: "モナコ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/vmb1OLavG",
        //         code: "Monaco"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     AX: [
        //       {
        //         title: "オーランド諸島 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/aNXYkYmrQ",
        //         code: "Åland Islands"
        //       },
        //       {
        //         title: "オーランド諸島 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/e8r2n1k59",
        //         code: "Åland Islands"
        //       },
        //       {
        //         title: "オーランド諸島 Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/4aA0RQZ58",
        //         code: "Åland Islands"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     SM: [
        //       {
        //         title: "サンマリノ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvR298",
        //         code: "San Marino"
        //       },
        //       {
        //         title: "サンマリノ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/BpyALmXJm",
        //         code: "San Marino"
        //       },
        //       {
        //         title: "サンマリノ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/LL3aO9dZg",
        //         code: "San Marino"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     NL: [
        //       {
        //         title: "オランダ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/m1zLMLOp9",
        //         code: "Netherlands"
        //       },
        //       {
        //         title: "オランダ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6KBym",
        //         code: "Netherlands"
        //       },
        //       {
        //         title: "オランダ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/3badoneG0",
        //         code: "Netherlands"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     BE: [
        //       {
        //         title: "ベルギー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAmA0Z",
        //         code: "Belgium"
        //       },
        //       {
        //         title: "ベルギー 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8wG2a6",
        //         code: "Belgium"
        //       },
        //       {
        //         title: "ベルギー Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/brmRvy9rr",
        //         code: "Belgium"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     LU: [
        //       {
        //         title: "ルクセンブルグ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPXy7o",
        //         code: "Luxembourg"
        //       },
        //       {
        //         title: "ルクセンブルグ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/m1zLkYEJ9",
        //         code: "Luxembourg"
        //       },
        //       {
        //         title: "ルクセンブルグ Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/QVladOgPk",
        //         code: "Luxembourg"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 35 countries Unlimited プラン",
        //         price: "NTD 250",
        //         labels: ["1 day", "Unlimited"],
        //         url: "https://dl.gl/2rNd0KAAO",
        //         code: "Europe 35 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     CY: [
        //       {
        //         title: "キプロス 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/wG5mnmyrg",
        //         code: "Cyprus"
        //       },
        //       {
        //         title: "キプロス 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zdLEN",
        //         code: "Cyprus"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       }
        //     ],
        //     GR: [
        //       {
        //         title: "ギリシャ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQY8KN",
        //         code: "Greece"
        //       },
        //       {
        //         title: "ギリシャ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OLm0G",
        //         code: "Greece"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     HU: [
        //       {
        //         title: "ハンガリー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/kLgMbMplQ",
        //         code: "Hungary"
        //       },
        //       {
        //         title: "ハンガリー 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJeOVD",
        //         code: "Hungary"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     LT: [
        //       {
        //         title: "リトアニア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Epz8L8nYw",
        //         code: "Lithuania"
        //       },
        //       {
        //         title: "リトアニア 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRvamV0",
        //         code: "Lithuania"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     RS: [
        //       {
        //         title: "セルビア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRME8ZK",
        //         code: "Serbia"
        //       },
        //       {
        //         title: "セルビア 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/VY8m4P8Ja",
        //         code: "Serbia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     ME: [
        //       {
        //         title: "モンテネグロ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRLREPX",
        //         code: "Montenegro"
        //       },
        //       {
        //         title: "モンテネグロ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/kLgMbY9m1",
        //         code: "Montenegro"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       }
        //     ],
        //     GG: [
        //       {
        //         title: "ガーンジー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8R8OmO",
        //         code: "Guernsey"
        //       },
        //       {
        //         title: "ガーンジー 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/aNXYkRPVZ",
        //         code: "Guernsey"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     JE: [
        //       {
        //         title: "ジャージー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/rRw1A1A4L",
        //         code: "Jersey"
        //       },
        //       {
        //         title: "ジャージー 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1PmwrY",
        //         code: "Jersey"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     IM: [
        //       {
        //         title: "マン島 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQY8Jv",
        //         code: "Isle of man"
        //       },
        //       {
        //         title: "マン島 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/829am699Y",
        //         code: "Isle of man"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     BA: [
        //       {
        //         title: "ボスニア・ヘルツェゴビナ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKmAebLv",
        //         code: "Bosnia and Herzegovina"
        //       },
        //       {
        //         title: "ボスニア・ヘルツェゴビナ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badoQzKp",
        //         code: "Bosnia and Herzegovina"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       }
        //     ],
        //     GI: [
        //       {
        //         title: "ジブラルタル 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoEMap",
        //         code: "Gibraltar"
        //       },
        //       {
        //         title: "ジブラルタル 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/829am67K2",
        //         code: "Gibraltar"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       }
        //     ],
        //     AL: [
        //       {
        //         title: "アルバニア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/XvpYJvZkQ",
        //         code: "Albania"
        //       },
        //       {
        //         title: "アルバニア 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8Ll28g",
        //         code: "Albania"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MK: [
        //       {
        //         title: "マケドニア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/LL3a6Llb7",
        //         code: "Macedonia"
        //       },
        //       {
        //         title: "マケドニア 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8LlPgy",
        //         code: "Macedonia"
        //       },
        //       {
        //         title: "Europe 48 countries 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2ynrZo",
        //         code: "Europe 48 countries"
        //       },
        //       {
        //         title: "Europe 48 countries 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/AAYRLXz7e",
        //         code: "Europe 48 countries"
        //       }
        //     ],
        //     EG: [
        //       {
        //         title: "エジプト 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badodnzQ",
        //         code: "Egypt"
        //       },
        //       {
        //         title: "エジプト 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXP6ayo",
        //         code: "Egypt"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MA: [
        //       {
        //         title: "モロッコ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/kLgMbML81",
        //         code: "Morocco"
        //       },
        //       {
        //         title: "モロッコ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArwGO",
        //         code: "Morocco"
        //       }
        //     ],
        //     KE: [
        //       {
        //         title: "ケニア 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladVBJ0",
        //         code: "Kenya"
        //       },
        //       {
        //         title: "ケニア 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Oo5LRvDN8",
        //         code: "Kenya"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     EH: [
        //       {
        //         title: "西サハラ 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/okODLkVNJ",
        //         code: "Western Sahara"
        //       },
        //       {
        //         title: "西サハラ 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/G4OpLmkRM",
        //         code: "Western Sahara"
        //       }
        //     ],
        //     GH: [
        //       {
        //         title: "ガーナ 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4Op8NR6M",
        //         code: "Ghana"
        //       },
        //       {
        //         title: "ガーナ 1GB プラン",
        //         price: "NTD 369",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/BpyALdk71",
        //         code: "Ghana"
        //       }
        //     ],
        //     ZA: [
        //       {
        //         title: "南アフリカ 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/796Dm9l5D",
        //         code: "South Africa"
        //       },
        //       {
        //         title: "南アフリカ 1GB プラン",
        //         price: "NTD 369",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/e8r2nMJ8v",
        //         code: "South Africa"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MG: [
        //       {
        //         title: "マダガスカル 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badobwop",
        //         code: "Madagascar"
        //       },
        //       {
        //         title: "マダガスカル 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXVVz",
        //         code: "Madagascar"
        //       }
        //     ],
        //     DZ: [
        //       {
        //         title: "アルジェリア 500MB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/dRo6ORVX1",
        //         code: "Algeria"
        //       },
        //       {
        //         title: "アルジェリア 1GB プラン",
        //         price: "NTD 399",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/dRo6ONAeV",
        //         code: "Algeria"
        //       }
        //     ],
        //     ZM: [
        //       {
        //         title: "ザンビア 500MB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvr4Qw",
        //         code: "Zambia"
        //       },
        //       {
        //         title: "ザンビア 1GB プラン",
        //         price: "NTD 429",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmdBLm",
        //         code: "Zambia"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MU: [
        //       {
        //         title: "モーリシャス 500MB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpL4mnZ",
        //         code: "Mauritius"
        //       },
        //       {
        //         title: "モーリシャス 1GB プラン",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/LL3a6vgbz",
        //         code: "Mauritius"
        //       }
        //     ],
        //     NG: [
        //       {
        //         title: "ナイジェリア 500MB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badobA01",
        //         code: "Nigeria"
        //       },
        //       {
        //         title: "ナイジェリア 1GB プラン",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oAOK7",
        //         code: "Nigeria"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     TN: [
        //       {
        //         title: "チュニジア 500MB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/G4OpL4ezZ",
        //         code: "Tunisia"
        //       },
        //       {
        //         title: "チュニジア 1GB プラン",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6YGEzZ",
        //         code: "Tunisia"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     TZ: [
        //       {
        //         title: "タンザニア 500MB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9EePB2",
        //         code: "Tanzania"
        //       },
        //       {
        //         title: "タンザニア 1GB プラン",
        //         price: "NTD 549",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJenOK",
        //         code: "Tanzania"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     AO: [
        //       {
        //         title: "アンゴラ 500MB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2n8YEk",
        //         code: "Angola"
        //       },
        //       {
        //         title: "アンゴラ 1GB プラン",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/zeD9E5z43",
        //         code: "Angola"
        //       }
        //     ],
        //     AU: [
        //       {
        //         title: "オーストラリア 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPzwzzKD",
        //         code: "Australia"
        //       },
        //       {
        //         title: "オーストラリア 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRva6Vn",
        //         code: "Australia"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ",
        //         code: "New Zealand,Australia,Fiji"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLme9G",
        //         code: "New Zealand,Australia,Fiji"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     NZ: [
        //       {
        //         title: "ニュージーランド 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/llLXPX55g",
        //         code: "New Zealand"
        //       },
        //       {
        //         title: "ニュージーランド 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/gmPzwYZ8w",
        //         code: "New Zealand"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ",
        //         code: "New Zealand,Australia,Fiji"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLme9G",
        //         code: "New Zealand,Australia,Fiji"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     FJ: [
        //       {
        //         title: "フィジー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9vKQ4",
        //         code: "Fiji"
        //       },
        //       {
        //         title: "フィジー 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/PVMZP7Va9",
        //         code: "Fiji"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/J4w6YGrJZ",
        //         code: "New Zealand,Australia,Fiji"
        //       },
        //       {
        //         title: "New Zealand,Australia,Fiji 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLme9G",
        //         code: "New Zealand,Australia,Fiji"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     GU: [
        //       {
        //         title: "グアム 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/YmKYAYaNP",
        //         code: "Guam"
        //       },
        //       {
        //         title: "グアム 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/okODLmemw",
        //         code: "Guam"
        //       },
        //       {
        //         title: "Guam, Saipan 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoQZNY",
        //         code: "Guam, Saipan"
        //       },
        //       {
        //         title: "Guam, Saipan 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oAMnZ",
        //         code: "Guam, Saipan"
        //       }
        //     ],
        //     MP: [
        //       {
        //         title: "サイパン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvrX9w",
        //         code: "Saipan"
        //       },
        //       {
        //         title: "サイパン 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJe9LP",
        //         code: "Saipan"
        //       },
        //       {
        //         title: "Guam, Saipan 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badoQZNY",
        //         code: "Guam, Saipan"
        //       },
        //       {
        //         title: "Guam, Saipan 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oAMnZ",
        //         code: "Guam, Saipan"
        //       }
        //     ],
        //     US: [
        //       {
        //         title: "アメリカ 500MB プラン",
        //         price: "NTD 99",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvRnLK",
        //         code: "United States"
        //       },
        //       {
        //         title: "アメリカ 1GB プラン",
        //         price: "NTD 190",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/Epz8LlJJy",
        //         code: "United States"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv",
        //         code: "United States, Canada, Mexico"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G",
        //         code: "United States, Canada, Mexico"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     CA: [
        //       {
        //         title: "カナダ 500MB プラン",
        //         price: "NTD 110",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/e8r2n2951",
        //         code: "Canada"
        //       },
        //       {
        //         title: "カナダ 1GB プラン",
        //         price: "NTD 215",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OdJ7Q",
        //         code: "Canada"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv",
        //         code: "United States, Canada, Mexico"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G",
        //         code: "United States, Canada, Mexico"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     MX: [
        //       {
        //         title: "メキシコ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/9KXv9vvlM",
        //         code: "Mexico"
        //       },
        //       {
        //         title: "メキシコ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/MK28ReQm1",
        //         code: "Mexico"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/1aKm3K6Vv",
        //         code: "United States, Canada, Mexico"
        //       },
        //       {
        //         title: "United States, Canada, Mexico 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/J4w6p2Q4G",
        //         code: "United States, Canada, Mexico"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     PR: [
        //       {
        //         title: "プエルトリコ 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/PVMZLGYz2",
        //         code: "Puerto Rico"
        //       },
        //       {
        //         title: "プエルトリコ 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/4aA0zewgK",
        //         code: "Puerto Rico"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     GP: [
        //       {
        //         title: "グアドループ 500MB プラン",
        //         price: "NTD 189",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/KbEmRmzwa",
        //         code: "Guadeloupe"
        //       },
        //       {
        //         title: "グアドループ 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1Pm4lY",
        //         code: "Guadeloupe"
        //       }
        //     ],
        //     MF: [
        //       {
        //         title: "セントマーティン 500MB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/PVMZPaKLZ",
        //         code: "Saint Martin"
        //       },
        //       {
        //         title: "セントマーティン 1GB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/vmb1OLKO2",
        //         code: "Saint Martin"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     AG: [
        //       {
        //         title: "アンティグアバーブーダ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1PVKXe",
        //         code: "Antigua and Barbuda"
        //       },
        //       {
        //         title: "アンティグアバーブーダ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1PmbYb",
        //         code: "Antigua and Barbuda"
        //       }
        //     ],
        //     AW: [
        //       {
        //         title: "アルバ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/brmRvrv4r",
        //         code: "Aruba"
        //       },
        //       {
        //         title: "アルバ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/6bZXmdJB7",
        //         code: "Aruba"
        //       }
        //     ],
        //     KY: [
        //       {
        //         title: "ケイマン諸島 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/wG5mnG6O5",
        //         code: "Cayman Islands"
        //       },
        //       {
        //         title: "ケイマン諸島 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/0opLBXKOA",
        //         code: "Cayman Islands"
        //       }
        //     ],
        //     CW: [
        //       {
        //         title: "キュラソー 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/QVladVGyo",
        //         code: "Curacao"
        //       },
        //       {
        //         title: "キュラソー 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/796Dm3NkN",
        //         code: "Curacao"
        //       }
        //     ],
        //     GD: [
        //       {
        //         title: "グリナダ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Nlb8Rl8Gv",
        //         code: "Grenada"
        //       },
        //       {
        //         title: "グリナダ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/llLXPmD4O",
        //         code: "Grenada"
        //       }
        //     ],
        //     HT: [
        //       {
        //         title: "ハイチ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/829am2oln",
        //         code: "Haiti"
        //       },
        //       {
        //         title: "ハイチ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/pVnA1X4lQ",
        //         code: "Haiti"
        //       }
        //     ],
        //     JM: [
        //       {
        //         title: "ジャマイカ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnA1VB4w",
        //         code: "Jamaica"
        //       },
        //       {
        //         title: "ジャマイカ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXayz",
        //         code: "Jamaica"
        //       }
        //     ],
        //     TT: [
        //       {
        //         title: "トリニダード・トバゴ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/pVnAvl5X4",
        //         code: "Trinidad and Tobago"
        //       },
        //       {
        //         title: "トリニダード・トバゴ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/3badoQZK1",
        //         code: "Trinidad and Tobago"
        //       }
        //     ],
        //     TC: [
        //       {
        //         title: "タークスカイコス諸島 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/nVG1PVBDm",
        //         code: "Turks and Caicos Islands"
        //       },
        //       {
        //         title: "タークスカイコス諸島 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/2rNd0KnkR",
        //         code: "Turks and Caicos Islands"
        //       }
        //     ],
        //     MQ: [
        //       {
        //         title: "フレンチマーティン 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQEmJB",
        //         code: "Martinique"
        //       },
        //       {
        //         title: "フレンチマーティン 1GB プラン",
        //         price: "NTD 699",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/G4OpLml0R",
        //         code: "Martinique"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     AI: [
        //       {
        //         title: "アンギラ 500MB プラン",
        //         price: "NTD 489",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/KbEmRb3NL",
        //         code: "Anguilla"
        //       },
        //       {
        //         title: "アンギラ 1GB プラン",
        //         price: "NTD 819",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ZENYQP4y1",
        //         code: "Anguilla"
        //       }
        //     ],
        //     VG: [
        //       {
        //         title: "イギリス領ヴァージン諸島 500MB プラン",
        //         price: "NTD 489",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmb0m8",
        //         code: "British Virgin Islands"
        //       },
        //       {
        //         title: "イギリス領ヴァージン諸島 1GB プラン",
        //         price: "NTD 819",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/5Qd7oA1vl",
        //         code: "British Virgin Islands"
        //       }
        //     ],
        //     VC: [
        //       {
        //         title: "セントビンセント・グレナディーン 500MB プラン",
        //         price: "NTD 489",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/AAYRLA573",
        //         code: "Saint Vincent and the Grenadines"
        //       },
        //       {
        //         title: "セントビンセント・グレナディーン 1GB プラン",
        //         price: "NTD 819",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1Pmgpe",
        //         code: "Saint Vincent and the Grenadines"
        //       }
        //     ],
        //     AR: [
        //       {
        //         title: "アルゼンチン 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/Epz8L8dgL",
        //         code: "Argentina"
        //       },
        //       {
        //         title: "アルゼンチン 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/DKLB0MXZV",
        //         code: "Argentina"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm",
        //         code: "Argentina, Brazil, Peru"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArk37",
        //         code: "Argentina, Brazil, Peru"
        //       }
        //     ],
        //     BR: [
        //       {
        //         title: "ブラジル 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/YmKYe301n",
        //         code: "Brazil"
        //       },
        //       {
        //         title: "ブラジル 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/XvpYJa4MK",
        //         code: "Brazil"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm",
        //         code: "Argentina, Brazil, Peru"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArk37",
        //         code: "Argentina, Brazil, Peru"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     PE: [
        //       {
        //         title: "ペルー 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/4aA063ZBk",
        //         code: "Peru"
        //       },
        //       {
        //         title: "ペルー 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVlaevrpR",
        //         code: "Peru"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 500MB プラン",
        //         price: "NTD 129",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmdPZm",
        //         code: "Argentina, Brazil, Peru"
        //       },
        //       {
        //         title: "Argentina, Brazil, Peru 1GB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKmArk37",
        //         code: "Argentina, Brazil, Peru"
        //       }
        //     ],
        //     CO: [
        //       {
        //         title: "コロンビア 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/796Dm9O3V",
        //         code: "Colombia"
        //       },
        //       {
        //         title: "コロンビア 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/QVladv3eo",
        //         code: "Colombia"
        //       }
        //     ],
        //     UY: [
        //       {
        //         title: "ウルグアイ 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/LL3a6LELv",
        //         code: "Uruguay"
        //       },
        //       {
        //         title: "ウルグアイ 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/nVG1PmDDm",
        //         code: "Uruguay"
        //       }
        //     ],
        //     VE: [
        //       {
        //         title: "ベネズエラ 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/6bZXmXdm7",
        //         code: "Venezuela"
        //       },
        //       {
        //         title: "ベネズエラ 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ZENYQP5VB",
        //         code: "Venezuela"
        //       }
        //     ],
        //     GY: [
        //       {
        //         title: "ガイアナ 500MB プラン",
        //         price: "NTD 159",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/okODLkaDe",
        //         code: "Guyana"
        //       },
        //       {
        //         title: "ガイアナ 1GB プラン",
        //         price: "NTD 309",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/9KXv9JQEr",
        //         code: "Guyana"
        //       }
        //     ],
        //     PA: [
        //       {
        //         title: "パナマ 500MB プラン",
        //         price: "NTD 219",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/gmPz4DpMo",
        //         code: "Panama"
        //       },
        //       {
        //         title: "パナマ 1GB プラン",
        //         price: "NTD 399",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXeO3",
        //         code: "Panama"
        //       }
        //     ],
        //     CL: [
        //       {
        //         title: "チリ 500MB プラン",
        //         price: "NTD 249",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/RLDm4L91P",
        //         code: "Chile"
        //       },
        //       {
        //         title: "チリ 1GB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/829am6m8P",
        //         code: "Chile"
        //       },
        //       {
        //         title: "Global 82 countries 10GB プラン",
        //         price: "NTD 2200",
        //         labels: ["1年", "10GB"],
        //         url: "https://dl.gl/2rNymeX4V",
        //         code: "Global 82 countries"
        //       }
        //     ],
        //     BO: [
        //       {
        //         title: "ボリビア 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/YmKYAmmD4",
        //         code: "Bolivia"
        //       },
        //       {
        //         title: "ボリビア 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/brmRvaJ6m",
        //         code: "Bolivia"
        //       }
        //     ],
        //     CR: [
        //       {
        //         title: "コスタリカ 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/0opLB05wA",
        //         code: "Costa Rica"
        //       },
        //       {
        //         title: "コスタリカ 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/ynl8wb5vg",
        //         code: "Costa Rica"
        //       }
        //     ],
        //     SR: [
        //       {
        //         title: "スリナム 500MB プラン",
        //         price: "NTD 339",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/KbEmRb9pd",
        //         code: "Suriname"
        //       },
        //       {
        //         title: "スリナム 1GB プラン",
        //         price: "NTD 579",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/PVMZLGlOR",
        //         code: "Suriname"
        //       }
        //     ],
        //     EC: [
        //       {
        //         title: "エクアドル 500MB プラン",
        //         price: "NTD 369",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/aNXYkNl3v",
        //         code: "Ecuador"
        //       },
        //       {
        //         title: "エクアドル 1GB プラン",
        //         price: "NTD 609",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5mnXzMV",
        //         code: "Ecuador"
        //       }
        //     ],
        //     DO: [
        //       {
        //         title: "ドミニカ共和国 500MB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYQE5L4",
        //         code: "The Dominican Republic"
        //       },
        //       {
        //         title: "ドミニカ共和国 1GB プラン",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/wG5m4XBbg",
        //         code: "The Dominican Republic"
        //       }
        //     ],
        //     GT: [
        //       {
        //         title: "グアテマラ 500MB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/3badobL8Q",
        //         code: "Guatemala"
        //       },
        //       {
        //         title: "グアテマラ 1GB プラン",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/796Dm3N2m",
        //         code: "Guatemala"
        //       }
        //     ],
        //     NI: [
        //       {
        //         title: "ニカラグア 500MB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/ZENYDM1B4",
        //         code: "Nicaragua"
        //       },
        //       {
        //         title: "ニカラグア 1GB プラン",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/RLDm4bpvr",
        //         code: "Nicaragua"
        //       }
        //     ],
        //     SV: [
        //       {
        //         title: "サルバドール 500MB プラン",
        //         price: "NTD 459",
        //         labels: ["1 day", "500MB"],
        //         url: "https://dl.gl/zeD9YekLn",
        //         code: "El Salvador"
        //       },
        //       {
        //         title: "サルバドール 1GB プラン",
        //         price: "NTD 789",
        //         labels: ["1 day", "1GB"],
        //         url: "https://dl.gl/1aKm1G9VO",
        //         code: "El Salvador"
        //       }
        //     ]
        //   }
        // },
        USD: {
          en: {
            GLOBAL: [],
            JP: [
              {
                title: "Japan 3GB package",
                price: "USD 2",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/3dXR6QydD",
              },
            ],
            KR: [
              {
                title: "Korea 3GB package",
                price: "USD 2.5",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/e2N0K1Eww",
              },
            ],
            TW: [
              {
                title: "Taiwan 3GB package",
                price: "USD 2",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/Rmv0G9eQe",
              },
            ],
            CN: [
              {
                title: "China 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VmL0wOa99",
              },
              {
                title: "China 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6nDAg",
              },
            ],
            HK: [
              {
                title: "Hong Kong  (China) 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GbYQr",
              },
              {
                title: "Hong Kong  (China) 3GB package",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/OLE06v6Pr",
              },
            ],
            MO: [
              {
                title: "Macao (China) 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pNyZZ",
              },
              {
                title: "Macao (China) 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGdG6m",
              },
            ],
            SG: [
              {
                title: "Singapore 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYBl5GX",
              },
            ],
            MY: [
              {
                title: "Malaysia 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AR8rlkM2X",
              },
              {
                title: "Malaysia 3GB package",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/mLm9Xp5m1",
              },
            ],
            TH: [
              {
                title: "Thailand 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rm27z",
              },
              {
                title: "Thailand 3GB package",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/XYm03o8EO",
              },
            ],
            VN: [
              {
                title: "VietNam 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9vbdeZK0E",
              },
              {
                title: "VietNam 3GB package",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/M8v0dZ3Dg",
              },
            ],
            ID: [
              {
                title: "Indonesia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXAPvJ",
              },
              {
                title: "Indonesia 3GB package",
                price: "USD 6.8",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/OLE069r6P",
              },
            ],
            PH: [
              {
                title: "Philippines 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RmEzZ",
              },
              {
                title: "Philippines 3GB package",
                price: "USD 6.8",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/E8rYBaGzP",
              },
            ],
            KH: [
              {
                title: "Cambodia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/oDPEgzDB5",
              },
              {
                title: "Cambodia 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDgXBBQ",
              },
            ],
            LA: [
              {
                title: "Laos 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAnaAM9",
              },
              {
                title: "Laos 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PZ401voYZ",
              },
            ],
            MM: [
              {
                title: "Myanmar 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RpkM6",
              },
              {
                title: "Myanmar 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZYv09My3V",
              },
            ],
            IN: [
              {
                title: "India 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401Zl7R",
              },
              {
                title: "India 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AR8rl0bD5",
              },
            ],
            IL: [
              {
                title: "Israel 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401ZlEB",
              },
              {
                title: "Israel 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0X2yPR",
              },
            ],
            BD: [
              {
                title: "Bangladesh 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0ZaMlm",
              },
              {
                title: "Bangladesh 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0ZaMPe",
              },
            ],
            LK: [
              {
                title: "Sri Lanka 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/bRw08Rd4r",
              },
              {
                title: "Sri Lanka 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AR8rl0QEb",
              },
            ],
            NP: [
              {
                title: "Nepal 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/n1pwg1AY5",
              },
              {
                title: "Nepal 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/z978gJ6zL",
              },
            ],
            JO: [
              {
                title: "Jordan 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaODB3P",
              },
              {
                title: "Jordan 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/bRw08y8GK",
              },
            ],
            MN: [
              {
                title: "Mongolia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAna5PP",
              },
              {
                title: "Mongolia 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XpQAX",
              },
            ],
            QA: [
              {
                title: "Qatar 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKX73bl",
              },
              {
                title: "Qatar 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6n9O0",
              },
            ],
            SA: [
              {
                title: "Saudi Arabia 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGXvdQ",
              },
              {
                title: "Saudi Arabia 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0X2zd3",
              },
            ],
            BN: [
              {
                title: "Brunei 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaODl7V",
              },
              {
                title: "Brunei 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XpGYk",
              },
            ],
            MV: [
              {
                title: "Maldives 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKX7pPa",
              },
              {
                title: "Maldives 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYBa47J",
              },
            ],
            BH: [
              {
                title: "Bahrain 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZdB7o",
              },
              {
                title: "Bahrain 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391dbgM",
              },
            ],
            PK: [
              {
                title: "Pakistan 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/M8v0dKEPM",
              },
              {
                title: "Pakistan 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391dyYK",
              },
            ],
            KZ: [
              {
                title: "Kazakhstan 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RpXyZ",
              },
              {
                title: "Kazakhstan 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BAaQDmM1Y",
              },
            ],
            AE: [
              {
                title: "UAE 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6dVbe",
              },
              {
                title: "UAE 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0X2zDX",
              },
            ],
            AZ: [
              {
                title: "Azerbaijan 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/v1EDg1684",
              },
              {
                title: "Azerbaijan 1GB package",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09v2RL",
              },
            ],
            AM: [
              {
                title: "Armenia 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/40391aPa8",
              },
              {
                title: "Armenia 1GB package",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630pKOn2",
              },
            ],
            GE: [
              {
                title: "Georgia 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKX7wGa",
              },
              {
                title: "Georgia 1GB package",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40AK6BM",
              },
            ],
            OM: [
              {
                title: "Oman 500MB package",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6b8Bm",
              },
              {
                title: "Oman 1GB package",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VmL0wO60a",
              },
            ],
            KW: [
              {
                title: "Kuwait 500MB package",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AR8rlA3oe",
              },
              {
                title: "Kuwait 1GB package",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Rmv0G9arl",
              },
            ],
            TJ: [
              {
                title: "Tajikistan 500MB package",
                price: "USD 12.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0ZlBmL",
              },
              {
                title: "Tajikistan 1GB package",
                price: "USD 20.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VmL0wOmdm",
              },
            ],
            AT: [
              {
                title: "Austria 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1mzBdabwQ",
              },
              {
                title: "Austria 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/r1ObgP14P",
              },
              {
                title: "Austria 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/v1EDgX8a8",
              },
            ],
            BG: [
              {
                title: "Bulgaria 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GL0Rm",
              },
              {
                title: "Bulgaria 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGEXaO",
              },
              {
                title: "Bulgaria 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/aY80B4rll",
              },
            ],
            CH: [
              {
                title: "Switzerland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/OLE06o01J",
              },
              {
                title: "Switzerland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6nbgY",
              },
              {
                title: "Switzerland 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/n1pwg8B7Q",
              },
            ],
            CZ: [
              {
                title: "Czech Republic 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaO9e6n",
              },
              {
                title: "Czech Republic 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1Rl5B",
              },
              {
                title: "Czech Republic 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/8aVAnM0JE",
              },
            ],
            DE: [
              {
                title: "Germany 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pRV49",
              },
              {
                title: "Germany 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKX00G7",
              },
              {
                title: "Germany 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/Kmz09vwNv",
              },
            ],
            DK: [
              {
                title: "Denmark 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGbBz9",
              },
              {
                title: "Denmark 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1RmYE",
              },
              {
                title: "Denmark 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/40391dDlb",
              },
            ],
            EE: [
              {
                title: "Estonia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaO9dPP",
              },
              {
                title: "Estonia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gzL7aNDXz",
              },
              {
                title: "Estonia 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/wm3VgAOyg",
              },
            ],
            ES: [
              {
                title: "Spain 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gzL7amE4k",
              },
              {
                title: "Spain 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gzL7aYnno",
              },
              {
                title: "Spain 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/N8v0Z4oEv",
              },
            ],
            FI: [
              {
                title: "Finland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gzL7am2Pk",
              },
              {
                title: "Finland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDgLkGL",
              },
              {
                title: "Finland 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/AR8rl0EQX",
              },
            ],
            FR: [
              {
                title: "France 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaO9ggd",
              },
              {
                title: "France 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gzL7aYPZR",
              },
              {
                title: "France 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/7DXaOQlMJ",
              },
            ],
            GB: [
              {
                title: "United Kingdom 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0LakAogmN",
              },
              {
                title: "United Kingdom 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZYv09Pkb1",
              },
              {
                title: "United Kingdom 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/ZYv09M571",
              },
            ],
            HR: [
              {
                title: "Croatia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03vRNK",
              },
              {
                title: "Croatia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0NLl4R",
              },
              {
                title: "Croatia 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/3dXR6nLmg",
              },
            ],
            IE: [
              {
                title: "Ireland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aY80BNB8Y",
              },
              {
                title: "Ireland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/M8v0de0Ba",
              },
              {
                title: "Ireland 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/3dXR6n2EO",
              },
            ],
            IS: [
              {
                title: "Iceland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAn2352",
              },
              {
                title: "Iceland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8ZKJDO",
              },
              {
                title: "Iceland 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/0LakAn6Xk",
              },
            ],
            IT: [
              {
                title: "Italy 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pAN3gVevQ",
              },
              {
                title: "Italy 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1m9DQ",
              },
              {
                title: "Italy 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/7DXaOQb5y",
              },
            ],
            LV: [
              {
                title: "Latvia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYBp08v",
              },
              {
                title: "Latvia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391eV20",
              },
              {
                title: "Latvia 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/z978gOnpn",
              },
            ],
            MT: [
              {
                title: "Malta 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GLylm",
              },
              {
                title: "Malta 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/9vbdeA6Dk",
              },
              {
                title: "Malta 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/YYw02B49P",
              },
            ],
            NO: [
              {
                title: "Norway 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GLwre",
              },
              {
                title: "Norway 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1mD6g",
              },
              {
                title: "Norway 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/YYw02BbYV",
              },
            ],
            PL: [
              {
                title: "Poland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/La40ALO77",
              },
              {
                title: "Poland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGdVkO",
              },
              {
                title: "Poland 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/oDPEgNeb5",
              },
            ],
            PT: [
              {
                title: "Portugal 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw02mkJy",
              },
              {
                title: "Portugal 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wm3VgX8mg",
              },
              {
                title: "Portugal 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/Kmz09OaPA",
              },
            ],
            RO: [
              {
                title: "Romania 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw02mX0V",
              },
              {
                title: "Romania 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1mzBdr296",
              },
              {
                title: "Romania 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/M8v0dZBQl",
              },
            ],
            RU: [
              {
                title: "Russia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAn27oY",
              },
              {
                title: "Russia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wm3VgXKzg",
              },
              {
                title: "Russia 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/6XrNGEaR9",
              },
            ],
            SE: [
              {
                title: "Sweden 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6bYQ0",
              },
              {
                title: "Sweden 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDg10OG",
              },
              {
                title: "Sweden 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/lX0no2aXe",
              },
            ],
            SI: [
              {
                title: "Slovenia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaORXJK",
              },
              {
                title: "Slovenia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aY80BY0gZ",
              },
              {
                title: "Slovenia 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/La40AKKDR",
              },
            ],
            SK: [
              {
                title: "Slovakia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO61JoY",
              },
              {
                title: "Slovakia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Rmv0Gm0N5",
              },
              {
                title: "Slovakia 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/YYw02BaPB",
              },
            ],
            TR: [
              {
                title: "Turkey 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/bRw084z60",
              },
              {
                title: "Turkey 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630p6VGZ",
              },
              {
                title: "Turkey 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/40391eYDb",
              },
            ],
            UA: [
              {
                title: "Ukraine 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYBnnzy",
              },
              {
                title: "Ukraine 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1X9Bo",
              },
              {
                title: "Ukraine 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/r1ObgzMQL",
              },
            ],
            LI: [
              {
                title: "Liechtenstein 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/n1pwgJ48m",
              },
              {
                title: "Liechtenstein 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630p6L2Z",
              },
              {
                title: "Liechtenstein 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/6XrNGdZZD",
              },
            ],
            VA: [
              {
                title: "Vatican 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03EYw2",
              },
              {
                title: "Vatican 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0N6MQB",
              },
              {
                title: "Vatican 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/OLE06veMG",
              },
            ],
            MC: [
              {
                title: "Monaco 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/r1ObgNRYX",
              },
              {
                title: "Monaco 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630p697Y",
              },
              {
                title: "Monaco 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/BAaQDB4a3",
              },
            ],
            AX: [
              {
                title: "Åland Islands 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/mLm9XK0pa",
              },
              {
                title: "Åland Islands 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/n1pwg12oL",
              },
              {
                title: "Åland Islands 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/9vbdeAQyE",
              },
            ],
            SM: [
              {
                title: "San Marino 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/40391L0wk",
              },
              {
                title: "San Marino 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKX7D9B",
              },
              {
                title: "San Marino 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/pAN3gXJ17",
              },
            ],
            NL: [
              {
                title: "Netherlands 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9vbde3J8m",
              },
              {
                title: "Netherlands 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/mLm9X0yl1",
              },
            ],
            BE: [
              {
                title: "Belgium 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAnpE8Y",
              },
              {
                title: "Belgium 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/N8v0Z60Ev",
              },
            ],
            LU: [
              {
                title: "Luxembourg 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXMowG",
              },
              {
                title: "Luxembourg 3GB package",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/v1EDgLrlJ",
              },
            ],
            CY: [
              {
                title: "Cyprus 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6roVY",
              },
              {
                title: "Cyprus 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PZ401ZNJ2",
              },
            ],
            GR: [
              {
                title: "Greece 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZR0NR",
              },
              {
                title: "Greece 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kMVO6MQa1",
              },
            ],
            HU: [
              {
                title: "Hungary 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aY80BGDE1",
              },
              {
                title: "Hungary 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYB8DKg",
              },
            ],
            LT: [
              {
                title: "Lithuania 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGalR9",
              },
              {
                title: "Lithuania 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYB8XBJ",
              },
            ],
            RS: [
              {
                title: "Serbia 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0G6OaK",
              },
              {
                title: "Serbia 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/M8v0d83mg",
              },
            ],
            ME: [
              {
                title: "Montenegro 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0G6OVr",
              },
              {
                title: "Montenegro 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XLXzY",
              },
            ],
            GG: [
              {
                title: "Guernsey 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO68ARG",
              },
              {
                title: "Guernsey 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YYw02Y2GR",
              },
            ],
            JE: [
              {
                title: "Jersey 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw025J1V",
              },
              {
                title: "Jersey 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40Aa25b",
              },
            ],
            IM: [
              {
                title: "Isle of man 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6rZ9v",
              },
              {
                title: "Isle of man 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kMVO6MEl4",
              },
            ],
            BA: [
              {
                title: "Bosnia and Herzegovina 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZR7P5",
              },
              {
                title: "Bosnia and Herzegovina 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Gp60Rg90O",
              },
            ],
            GI: [
              {
                title: "Gibraltar 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Qav0XK1nl",
              },
              {
                title: "Gibraltar 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/403910yYN",
              },
            ],
            AL: [
              {
                title: "Albania 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rg5Yw",
              },
              {
                title: "Albania 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1mzBdmypQ",
              },
            ],
            MK: [
              {
                title: "Macedonia 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03bPEQ",
              },
              {
                title: "Macedonia 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYB80E3",
              },
            ],
            EG: [
              {
                title: "Egypt 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXMz4o",
              },
              {
                title: "Egypt 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/M8v0d8ab7",
              },
            ],
            MA: [
              {
                title: "Morocco 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0LakAKeoA",
              },
              {
                title: "Morocco 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8Zd3XV",
              },
            ],
            KE: [
              {
                title: "Kenya 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaORMVV",
              },
              {
                title: "Kenya 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/bRw08R5NM",
              },
            ],
            EH: [
              {
                title: "Western Sahara 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/40391Lk3K",
              },
              {
                title: "Western Sahara 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kMVO6Lw33",
              },
            ],
            GH: [
              {
                title: "Ghana 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/M8v0dArNg",
              },
              {
                title: "Ghana 1GB package",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0Zlkvl",
              },
            ],
            ZA: [
              {
                title: "South Africa 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DBdvkmzvk",
              },
              {
                title: "South Africa 1GB package",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZYv09YM4N",
              },
            ],
            MG: [
              {
                title: "Madagascar 500MB package",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AR8rlkM2X",
              },
              {
                title: "Madagascar 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BAaQDpnAk",
              },
            ],
            DZ: [
              {
                title: "Algeria 500MB package",
                price: "USD 9.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rg8E6",
              },
              {
                title: "Algeria 1GB package",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0Z8wEL",
              },
            ],
            ZM: [
              {
                title: "Zambia 500MB package",
                price: "USD 10.2",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pek69",
              },
              {
                title: "Zambia 1GB package",
                price: "USD 18.9",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8Zr5DJ",
              },
            ],
            MU: [
              {
                title: "Mauritius 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pAN3gpveX",
              },
              {
                title: "Mauritius 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Rmv0GLYvm",
              },
            ],
            NG: [
              {
                title: "Nigeria 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Kmz09APEa",
              },
              {
                title: "Nigeria 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VmL0wYXOm",
              },
            ],
            TN: [
              {
                title: "Tunisia 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO684nY",
              },
              {
                title: "Tunisia 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6bavp",
              },
            ],
            TZ: [
              {
                title: "Tanzania 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DBdvkmDQw",
              },
              {
                title: "Tanzania 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BAaQDpyMe",
              },
            ],
            AO: [
              {
                title: "Angola 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/La40AYyKm",
              },
              {
                title: "Angola 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40AL3Yz",
              },
            ],
            AU: [
              {
                title: "Australia 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wm3VgreeG",
              },
              {
                title: "Australia 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0N4gZb",
              },
            ],
            NZ: [
              {
                title: "New Zealand 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401Dy0Z",
              },
              {
                title: "New Zealand 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8aVAn2rgO",
              },
            ],
            FJ: [
              {
                title: "Fiji 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aY80BG5GQ",
              },
              {
                title: "Fiji 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKXQmMG",
              },
            ],
            GU: [
              {
                title: "Guam 500MB package",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6rllO",
              },
              {
                title: "Guam 1GB package",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/7DXaO9KMP",
              },
            ],
            MP: [
              {
                title: "Saipan 500MB package",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1mzBd05Zg",
              },
              {
                title: "Saipan 1GB package",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09bw7L",
              },
            ],
            US: [
              {
                title: "United States 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pe8P2",
              },
              {
                title: "United States 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0ZlZBv",
              },
            ],
            CA: [
              {
                title: "Canada 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZRy8R",
              },
              {
                title: "Canada 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGbGKD",
              },
            ],
            MX: [
              {
                title: "Mexico 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Kmz09AJ8Y",
              },
              {
                title: "Mexico 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YYw02mNNb",
              },
            ],
            PR: [
              {
                title: "Puerto Rico 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0LakAKZep",
              },
              {
                title: "Puerto Rico 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0XVDOo",
              },
            ],
            GP: [
              {
                title: "Guadeloupe 500MB package",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGaw47",
              },
              {
                title: "Guadeloupe 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09b64e",
              },
            ],
            MF: [
              {
                title: "Saint Martin 500MB package",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401DlPP",
              },
              {
                title: "Saint Martin 1GB package",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/z978geMDm",
              },
            ],
            AG: [
              {
                title: "Antigua and Barbuda 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw0252mn",
              },
              {
                title: "Antigua and Barbuda 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pAN3gVGv4",
              },
            ],
            AW: [
              {
                title: "Aruba 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0Za55v",
              },
              {
                title: "Aruba 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1lBKB",
              },
            ],
            KY: [
              {
                title: "Cayman Islands 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RgRJ8",
              },
              {
                title: "Cayman Islands 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8aVAn2GwO",
              },
            ],
            CW: [
              {
                title: "Curacao 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/oDPEgzggQ",
              },
              {
                title: "Curacao 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKXQ5Nr",
              },
            ],
            GD: [
              {
                title: "Grenada 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/bRw08O18w",
              },
              {
                title: "Grenada 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/7DXaO9lVJ",
              },
            ],
            HT: [
              {
                title: "Haiti 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03b8dw",
              },
              {
                title: "Haiti 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/z978gevE3",
              },
            ],
            JM: [
              {
                title: "Jamaica 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/y8PBgr6yz",
              },
              {
                title: "Jamaica 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/7DXaO91am",
              },
            ],
            TT: [
              {
                title: "Trinidad and Tobago 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Qav0XKRZ3",
              },
              {
                title: "Trinidad and Tobago 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09bXky",
              },
            ],
            TC: [
              {
                title: "Turks and Caicos Islands 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/bRw084Zvn",
              },
            ],
            MQ: [
              {
                title: "Martinique 500MB package",
                price: "USD 18",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/oDPEgzVD1",
              },
              {
                title: "Martinique 1GB package",
                price: "USD 30.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/403915Yk8",
              },
            ],
            AI: [
              {
                title: "Anguilla 500MB package",
                price: "USD 21.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Kmz09AMGd",
              },
              {
                title: "Anguilla 1GB package",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKX2rNo",
              },
            ],
            VG: [
              {
                title: "British Virgin Islands 500MB package",
                price: "USD 21.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wm3Vgra0g",
              },
              {
                title: "British Virgin Islands 1GB package",
                price: "USD 35.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/n1pwgXXNL",
              },
            ],
            VC: [
              {
                title: "Saint Vincent and the Grenadines 500MB package",
                price: "USD 21.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGaBzy",
              },
              {
                title: "Saint Vincent and the Grenadines 1GB package",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391LL9N",
              },
            ],
            AR: [
              {
                title: "Argentina 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZYv098g11",
              },
              {
                title: "Argentina 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Gp60RwwaZ",
              },
            ],
            BR: [
              {
                title: "Brazil 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/BAaQDYX2z",
              },
              {
                title: "Brazil 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6GGZQ",
              },
            ],
            PE: [
              {
                title: "Peru 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaOReYK",
              },
              {
                title: "Peru 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKXnMRl",
              },
            ],
            CO: [
              {
                title: "Colombia 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZR6XA",
              },
              {
                title: "Colombia 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/r1ObgNYeV",
              },
            ],
            UY: [
              {
                title: "Uruguay 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXMmmo",
              },
              {
                title: "Uruguay 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8Z2XN5",
              },
            ],
            VE: [
              {
                title: "Venezuela 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0ZanoZ",
              },
              {
                title: "Venezuela 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDgPKoQ",
              },
            ],
            GY: [
              {
                title: "Guyana 500MB package",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9vbdeZNEN",
              },
              {
                title: "Guyana 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XKL49",
              },
            ],
            PA: [
              {
                title: "Panama 500MB package",
                price: "USD 9.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO68gZ1",
              },
              {
                title: "Panama 1GB package",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/oDPEgKDP1",
              },
            ],
            CL: [
              {
                title: "Chile 500MB package",
                price: "USD 11.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGaZwy",
              },
              {
                title: "Chile 1GB package",
                price: "USD 20.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391Oayo",
              },
            ],
            BO: [
              {
                title: "Bolivia 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rgb42",
              },
              {
                title: "Bolivia 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XYm03Eogy",
              },
            ],
            CR: [
              {
                title: "Costa Rica 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYB13bL",
              },
              {
                title: "Costa Rica 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0N2vz7",
              },
            ],
            SR: [
              {
                title: "Suriname 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6r4KY",
              },
              {
                title: "Suriname 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40A8Kr7",
              },
            ],
            EC: [
              {
                title: "Ecuador 500MB package",
                price: "USD 16",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03b4oy",
              },
              {
                title: "Ecuador 1GB package",
                price: "USD 27.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XYm03Ee92",
              },
            ],
            DO: [
              {
                title: "Dominican Republic 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e2N0KwG36",
              },
              {
                title: "Dominican Republic 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8ZR2KA",
              },
            ],
            GT: [
              {
                title: "Guatemala 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wm3VgrpQV",
              },
              {
                title: "Guatemala 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1mzBd3ewQ",
              },
            ],
            NI: [
              {
                title: "Nicaragua 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYB15Ly",
              },
              {
                title: "Nicaragua 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGerQM",
              },
            ],
            SV: [
              {
                title: "El Salvador 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/OLE06D4bL",
              },
              {
                title: "El Salvador 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/y8PBgLPwl",
              },
            ],
          },
          ja: {
            GLOBAL: [],
            JP: [
              {
                title: "日本 3GB",
                price: "USD 2",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/3dXR6QydD",
              },
            ],
            KR: [
              {
                title: "韓国 3GB",
                price: "USD 2.5",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/e2N0K1Eww",
              },
            ],
            TW: [
              {
                title: "台湾 3GB",
                price: "USD 2",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/Rmv0G9eQe",
              },
            ],
            CN: [
              {
                title: "中国 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VmL0wOa99",
              },
              {
                title: "中国 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6nDAg",
              },
            ],
            HK: [
              {
                title: "香港 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GbYQr",
              },
              {
                title: "香港 3GB",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/OLE06v6Pr",
              },
            ],
            MO: [
              {
                title: "マカオ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pNyZZ",
              },
              {
                title: "マカオ 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGdG6m",
              },
            ],
            SG: [
              {
                title: "シンガポール 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYBl5GX",
              },
            ],
            MY: [
              {
                title: "マレーシア 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AR8rlkM2X",
              },
              {
                title: "マレーシア 3GB",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/mLm9Xp5m1",
              },
            ],
            TH: [
              {
                title: "タイ 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rm27z",
              },
              {
                title: "タイ 3GB",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/XYm03o8EO",
              },
            ],
            VN: [
              {
                title: "ベトナム 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9vbdeZK0E",
              },
              {
                title: "ベトナム 3GB",
                price: "USD 4.3",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/M8v0dZ3Dg",
              },
            ],
            ID: [
              {
                title: "インドネシア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXAPvJ",
              },
              {
                title: "インドネシア 3GB",
                price: "USD 6.8",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/OLE069r6P",
              },
            ],
            PH: [
              {
                title: "フィリピン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RmEzZ",
              },
              {
                title: "フィリピン 3GB",
                price: "USD 6.8",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/E8rYBaGzP",
              },
            ],
            KH: [
              {
                title: "カンボジア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/oDPEgzDB5",
              },
              {
                title: "カンボジア 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDgXBBQ",
              },
            ],
            LA: [
              {
                title: "ラオス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAnaAM9",
              },
              {
                title: "ラオス 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PZ401voYZ",
              },
            ],
            MM: [
              {
                title: "ミャンマー 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RpkM6",
              },
              {
                title: "ミャンマー 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZYv09My3V",
              },
            ],
            IN: [
              {
                title: "インド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401Zl7R",
              },
              {
                title: "インド 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AR8rl0bD5",
              },
            ],
            IL: [
              {
                title: "イスラエル 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401ZlEB",
              },
              {
                title: "イスラエル 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0X2yPR",
              },
            ],
            BD: [
              {
                title: "バングラデシュ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0ZaMlm",
              },
              {
                title: "バングラデシュ 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0ZaMPe",
              },
            ],
            LK: [
              {
                title: "スリランカ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/bRw08Rd4r",
              },
              {
                title: "スリランカ 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AR8rl0QEb",
              },
            ],
            NP: [
              {
                title: "ネパール 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/n1pwg1AY5",
              },
              {
                title: "ネパール 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/z978gJ6zL",
              },
            ],
            JO: [
              {
                title: "ヨルダン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaODB3P",
              },
              {
                title: "ヨルダン 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/bRw08y8GK",
              },
            ],
            MN: [
              {
                title: "モンゴル国 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAna5PP",
              },
              {
                title: "モンゴル国 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XpQAX",
              },
            ],
            QA: [
              {
                title: "カタール 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKX73bl",
              },
              {
                title: "カタール 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6n9O0",
              },
            ],
            SA: [
              {
                title: "サウジアラビア 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGXvdQ",
              },
              {
                title: "サウジアラビア 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0X2zd3",
              },
            ],
            BN: [
              {
                title: "ブルネイ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaODl7V",
              },
              {
                title: "ブルネイ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XpGYk",
              },
            ],
            MV: [
              {
                title: "モルディブ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKX7pPa",
              },
              {
                title: "モルディブ 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYBa47J",
              },
            ],
            BH: [
              {
                title: "バーレーン 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZdB7o",
              },
              {
                title: "バーレーン 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391dbgM",
              },
            ],
            PK: [
              {
                title: "パキスタン 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/M8v0dKEPM",
              },
              {
                title: "パキスタン 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391dyYK",
              },
            ],
            KZ: [
              {
                title: "カザフ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RpXyZ",
              },
              {
                title: "カザフ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BAaQDmM1Y",
              },
            ],
            AE: [
              {
                title: "アラブ首長国連邦 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6dVbe",
              },
              {
                title: "アラブ首長国連邦 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0X2zDX",
              },
            ],
            AZ: [
              {
                title: "アゼルバイジャン 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/v1EDg1684",
              },
              {
                title: "アゼルバイジャン 1GB",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09v2RL",
              },
            ],
            AM: [
              {
                title: "アルメニア 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/40391aPa8",
              },
              {
                title: "アルメニア 1GB",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630pKOn2",
              },
            ],
            GE: [
              {
                title: "ジョージア 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKX7wGa",
              },
              {
                title: "ジョージア 1GB",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40AK6BM",
              },
            ],
            OM: [
              {
                title: "オマーン 500MB",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6b8Bm",
              },
              {
                title: "オマーン 1GB",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VmL0wO60a",
              },
            ],
            KW: [
              {
                title: "クウェート 500MB",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AR8rlA3oe",
              },
              {
                title: "クウェート 1GB",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Rmv0G9arl",
              },
            ],
            TJ: [
              {
                title: "タジキスタン 500MB",
                price: "USD 12.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0ZlBmL",
              },
              {
                title: "タジキスタン 1GB",
                price: "USD 20.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VmL0wOmdm",
              },
            ],
            AT: [
              {
                title: "オーストリア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1mzBdabwQ",
              },
              {
                title: "オーストリア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/r1ObgP14P",
              },
              {
                title: "オーストリア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/v1EDgX8a8",
              },
            ],
            BG: [
              {
                title: "ブルガリア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GL0Rm",
              },
              {
                title: "ブルガリア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGEXaO",
              },
              {
                title: "ブルガリア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/aY80B4rll",
              },
            ],
            CH: [
              {
                title: "スイス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/OLE06o01J",
              },
              {
                title: "スイス 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6nbgY",
              },
              {
                title: "スイス 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/n1pwg8B7Q",
              },
            ],
            CZ: [
              {
                title: "チェコ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaO9e6n",
              },
              {
                title: "チェコ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1Rl5B",
              },
              {
                title: "チェコ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/8aVAnM0JE",
              },
            ],
            DE: [
              {
                title: "ドイツ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pRV49",
              },
              {
                title: "ドイツ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKX00G7",
              },
              {
                title: "ドイツ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/Kmz09vwNv",
              },
            ],
            DK: [
              {
                title: "デンマーク 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGbBz9",
              },
              {
                title: "デンマーク 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1RmYE",
              },
              {
                title: "デンマーク 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/40391dDlb",
              },
            ],
            EE: [
              {
                title: "エストニア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaO9dPP",
              },
              {
                title: "エストニア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gzL7aNDXz",
              },
              {
                title: "エストニア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/wm3VgAOyg",
              },
            ],
            ES: [
              {
                title: "スペイン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gzL7amE4k",
              },
              {
                title: "スペイン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gzL7aYnno",
              },
              {
                title: "スペイン 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/N8v0Z4oEv",
              },
            ],
            FI: [
              {
                title: "フィンランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gzL7am2Pk",
              },
              {
                title: "フィンランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDgLkGL",
              },
              {
                title: "フィンランド 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/AR8rl0EQX",
              },
            ],
            FR: [
              {
                title: "フランス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaO9ggd",
              },
              {
                title: "フランス 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gzL7aYPZR",
              },
              {
                title: "フランス 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/7DXaOQlMJ",
              },
            ],
            GB: [
              {
                title: "イギリス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0LakAogmN",
              },
              {
                title: "イギリス 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZYv09Pkb1",
              },
              {
                title: "イギリス 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/ZYv09M571",
              },
            ],
            HR: [
              {
                title: "クロアチア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03vRNK",
              },
              {
                title: "クロアチア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0NLl4R",
              },
              {
                title: "クロアチア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/3dXR6nLmg",
              },
            ],
            IE: [
              {
                title: "アイルランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aY80BNB8Y",
              },
              {
                title: "アイルランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/M8v0de0Ba",
              },
              {
                title: "アイルランド 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/3dXR6n2EO",
              },
            ],
            IS: [
              {
                title: "アイスランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAn2352",
              },
              {
                title: "アイスランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8ZKJDO",
              },
              {
                title: "アイスランド 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/0LakAn6Xk",
              },
            ],
            IT: [
              {
                title: "イタリア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pAN3gVevQ",
              },
              {
                title: "イタリア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1m9DQ",
              },
              {
                title: "イタリア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/7DXaOQb5y",
              },
            ],
            LV: [
              {
                title: "ラトビア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYBp08v",
              },
              {
                title: "ラトビア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391eV20",
              },
              {
                title: "ラトビア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/z978gOnpn",
              },
            ],
            MT: [
              {
                title: "マルタ共和国 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GLylm",
              },
              {
                title: "マルタ共和国 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/9vbdeA6Dk",
              },
              {
                title: "マルタ共和国 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/YYw02B49P",
              },
            ],
            NO: [
              {
                title: "ノルウェー 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0GLwre",
              },
              {
                title: "ノルウェー 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1mD6g",
              },
              {
                title: "ノルウェー 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/YYw02BbYV",
              },
            ],
            PL: [
              {
                title: "ポーランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/La40ALO77",
              },
              {
                title: "ポーランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGdVkO",
              },
              {
                title: "ポーランド 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/oDPEgNeb5",
              },
            ],
            PT: [
              {
                title: "ポルトガル 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw02mkJy",
              },
              {
                title: "ポルトガル 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wm3VgX8mg",
              },
              {
                title: "ポルトガル 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/Kmz09OaPA",
              },
            ],
            RO: [
              {
                title: "ルーマニア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw02mX0V",
              },
              {
                title: "ルーマニア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1mzBdr296",
              },
              {
                title: "ルーマニア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/M8v0dZBQl",
              },
            ],
            RU: [
              {
                title: "ロシア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAn27oY",
              },
              {
                title: "ロシア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wm3VgXKzg",
              },
              {
                title: "ロシア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/6XrNGEaR9",
              },
            ],
            SE: [
              {
                title: "スウェーデン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6bYQ0",
              },
              {
                title: "スウェーデン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDg10OG",
              },
              {
                title: "スウェーデン 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/lX0no2aXe",
              },
            ],
            SI: [
              {
                title: "スロベニア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaORXJK",
              },
              {
                title: "スロベニア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aY80BY0gZ",
              },
              {
                title: "スロベニア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/La40AKKDR",
              },
            ],
            SK: [
              {
                title: "スロバキア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO61JoY",
              },
              {
                title: "スロバキア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Rmv0Gm0N5",
              },
              {
                title: "スロバキア 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/YYw02BaPB",
              },
            ],
            TR: [
              {
                title: "トルコ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/bRw084z60",
              },
              {
                title: "トルコ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630p6VGZ",
              },
              {
                title: "トルコ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/40391eYDb",
              },
            ],
            UA: [
              {
                title: "ウクライナ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYBnnzy",
              },
              {
                title: "ウクライナ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1X9Bo",
              },
              {
                title: "ウクライナ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/r1ObgzMQL",
              },
            ],
            LI: [
              {
                title: "リヒテンシュタイン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/n1pwgJ48m",
              },
              {
                title: "リヒテンシュタイン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630p6L2Z",
              },
              {
                title: "リヒテンシュタイン 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/6XrNGdZZD",
              },
            ],
            VA: [
              {
                title: "バチカン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03EYw2",
              },
              {
                title: "バチカン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0N6MQB",
              },
              {
                title: "バチカン 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/OLE06veMG",
              },
            ],
            MC: [
              {
                title: "モナコ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/r1ObgNRYX",
              },
              {
                title: "モナコ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/d630p697Y",
              },
              {
                title: "モナコ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/BAaQDB4a3",
              },
            ],
            AX: [
              {
                title: "オーランド諸島 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/mLm9XK0pa",
              },
              {
                title: "オーランド諸島 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/n1pwg12oL",
              },
              {
                title: "オーランド諸島 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/9vbdeAQyE",
              },
            ],
            SM: [
              {
                title: "サンマリノ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/40391L0wk",
              },
              {
                title: "サンマリノ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKX7D9B",
              },
              {
                title: "サンマリノ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/pAN3gXJ17",
              },
            ],
            NL: [
              {
                title: "オランダ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9vbde3J8m",
              },
              {
                title: "オランダ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/mLm9X0yl1",
              },
            ],
            BE: [
              {
                title: "ベルギー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8aVAnpE8Y",
              },
              {
                title: "ベルギー 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/N8v0Z60Ev",
              },
            ],
            LU: [
              {
                title: "ルクセンブルグ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXMowG",
              },
              {
                title: "ルクセンブルグ 3GB",
                price: "USD 9.4",
                labels: ["1 day", "3GB"],
                url: "https://dl.gl/v1EDgLrlJ",
              },
            ],
            CY: [
              {
                title: "キプロス 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6roVY",
              },
              {
                title: "キプロス 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PZ401ZNJ2",
              },
            ],
            GR: [
              {
                title: "ギリシャ 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZR0NR",
              },
              {
                title: "ギリシャ 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kMVO6MQa1",
              },
            ],
            HU: [
              {
                title: "ハンガリー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aY80BGDE1",
              },
              {
                title: "ハンガリー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYB8DKg",
              },
            ],
            LT: [
              {
                title: "リトアニア 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGalR9",
              },
              {
                title: "リトアニア 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYB8XBJ",
              },
            ],
            RS: [
              {
                title: "セルビア 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0G6OaK",
              },
              {
                title: "セルビア 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/M8v0d83mg",
              },
            ],
            ME: [
              {
                title: "モンテネグロ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Rmv0G6OVr",
              },
              {
                title: "モンテネグロ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XLXzY",
              },
            ],
            GG: [
              {
                title: "ガーンジー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO68ARG",
              },
              {
                title: "ガーンジー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YYw02Y2GR",
              },
            ],
            JE: [
              {
                title: "ジャージー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw025J1V",
              },
              {
                title: "ジャージー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40Aa25b",
              },
            ],
            IM: [
              {
                title: "マン島 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6rZ9v",
              },
              {
                title: "マン島 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kMVO6MEl4",
              },
            ],
            BA: [
              {
                title: "ボスニア・ヘルツェゴビナ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZR7P5",
              },
              {
                title: "ボスニア・ヘルツェゴビナ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Gp60Rg90O",
              },
            ],
            GI: [
              {
                title: "ジブラルタル 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Qav0XK1nl",
              },
              {
                title: "ジブラルタル 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/403910yYN",
              },
            ],
            AL: [
              {
                title: "アルバニア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rg5Yw",
              },
              {
                title: "アルバニア 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1mzBdmypQ",
              },
            ],
            MK: [
              {
                title: "マケドニア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03bPEQ",
              },
              {
                title: "マケドニア 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/E8rYB80E3",
              },
            ],
            EG: [
              {
                title: "エジプト 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXMz4o",
              },
              {
                title: "エジプト 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/M8v0d8ab7",
              },
            ],
            MA: [
              {
                title: "モロッコ 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0LakAKeoA",
              },
              {
                title: "モロッコ 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8Zd3XV",
              },
            ],
            KE: [
              {
                title: "ケニア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaORMVV",
              },
              {
                title: "ケニア 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/bRw08R5NM",
              },
            ],
            EH: [
              {
                title: "西サハラ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/40391Lk3K",
              },
              {
                title: "西サハラ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kMVO6Lw33",
              },
            ],
            GH: [
              {
                title: "ガーナ 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/M8v0dArNg",
              },
              {
                title: "ガーナ 1GB",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0Zlkvl",
              },
            ],
            ZA: [
              {
                title: "南アフリカ 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DBdvkmzvk",
              },
              {
                title: "南アフリカ 1GB",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZYv09YM4N",
              },
            ],
            MG: [
              {
                title: "マダガスカル 500MB",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AR8rlkM2X",
              },
              {
                title: "マダガスカル 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BAaQDpnAk",
              },
            ],
            DZ: [
              {
                title: "アルジェリア 500MB",
                price: "USD 9.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rg8E6",
              },
              {
                title: "アルジェリア 1GB",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0Z8wEL",
              },
            ],
            ZM: [
              {
                title: "ザンビア 500MB",
                price: "USD 10.2",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pek69",
              },
              {
                title: "ザンビア 1GB",
                price: "USD 18.9",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8Zr5DJ",
              },
            ],
            MU: [
              {
                title: "モーリシャス 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pAN3gpveX",
              },
              {
                title: "モーリシャス 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Rmv0GLYvm",
              },
            ],
            NG: [
              {
                title: "ナイジェリア 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Kmz09APEa",
              },
              {
                title: "ナイジェリア 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VmL0wYXOm",
              },
            ],
            TN: [
              {
                title: "チュニジア 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO684nY",
              },
              {
                title: "チュニジア 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6bavp",
              },
            ],
            TZ: [
              {
                title: "タンザニア 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DBdvkmDQw",
              },
              {
                title: "タンザニア 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BAaQDpyMe",
              },
            ],
            AO: [
              {
                title: "アンゴラ 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/La40AYyKm",
              },
              {
                title: "アンゴラ 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40AL3Yz",
              },
            ],
            AU: [
              {
                title: "オーストラリア 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wm3VgreeG",
              },
              {
                title: "オーストラリア 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0N4gZb",
              },
            ],
            NZ: [
              {
                title: "ニュージーランド 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401Dy0Z",
              },
              {
                title: "ニュージーランド 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8aVAn2rgO",
              },
            ],
            FJ: [
              {
                title: "フィジー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aY80BG5GQ",
              },
              {
                title: "フィジー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKXQmMG",
              },
            ],
            GU: [
              {
                title: "グアム 500MB",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6rllO",
              },
              {
                title: "グアム 1GB",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/7DXaO9KMP",
              },
            ],
            MP: [
              {
                title: "サイパン 500MB",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1mzBd05Zg",
              },
              {
                title: "サイパン 1GB",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09bw7L",
              },
            ],
            US: [
              {
                title: "アメリカ 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/d630pe8P2",
              },
              {
                title: "アメリカ 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/N8v0ZlZBv",
              },
            ],
            CA: [
              {
                title: "カナダ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZRy8R",
              },
              {
                title: "カナダ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGbGKD",
              },
            ],
            MX: [
              {
                title: "メキシコ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Kmz09AJ8Y",
              },
              {
                title: "メキシコ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YYw02mNNb",
              },
            ],
            PR: [
              {
                title: "プエルトリコ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0LakAKZep",
              },
              {
                title: "プエルトリコ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Qav0XVDOo",
              },
            ],
            GP: [
              {
                title: "グアドループ 500MB",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGaw47",
              },
              {
                title: "グアドループ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09b64e",
              },
            ],
            MF: [
              {
                title: "セントマーティン 500MB",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PZ401DlPP",
              },
              {
                title: "セントマーティン 1GB",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/z978geMDm",
              },
            ],
            AG: [
              {
                title: "アンティグアバーブーダ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YYw0252mn",
              },
              {
                title: "アンティグアバーブーダ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pAN3gVGv4",
              },
            ],
            AW: [
              {
                title: "アルバ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0Za55v",
              },
              {
                title: "アルバ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/lX0n1lBKB",
              },
            ],
            KY: [
              {
                title: "ケイマン諸島 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60RgRJ8",
              },
              {
                title: "ケイマン諸島 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8aVAn2GwO",
              },
            ],
            CW: [
              {
                title: "キュラソー 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/oDPEgzggQ",
              },
              {
                title: "キュラソー 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKXQ5Nr",
              },
            ],
            GD: [
              {
                title: "グリナダ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/bRw08O18w",
              },
              {
                title: "グリナダ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/7DXaO9lVJ",
              },
            ],
            HT: [
              {
                title: "ハイチ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03b8dw",
              },
              {
                title: "ハイチ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/z978gevE3",
              },
            ],
            JM: [
              {
                title: "ジャマイカ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/y8PBgr6yz",
              },
              {
                title: "ジャマイカ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/7DXaO91am",
              },
            ],
            TT: [
              {
                title: "トリニダード・トバゴ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Qav0XKRZ3",
              },
              {
                title: "トリニダード・トバゴ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Kmz09bXky",
              },
            ],
            TC: [
              {
                title: "タークスカイコス諸島 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/bRw084Zvn",
              },
            ],
            MQ: [
              {
                title: "フレンチマーティン 500MB",
                price: "USD 18",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/oDPEgzVD1",
              },
              {
                title: "フレンチマーティン 1GB",
                price: "USD 30.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/403915Yk8",
              },
            ],
            AI: [
              {
                title: "アンギラ 500MB",
                price: "USD 21.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Kmz09AMGd",
              },
              {
                title: "アンギラ 1GB",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKX2rNo",
              },
            ],
            VG: [
              {
                title: "イギリス領ヴァージン諸島 500MB",
                price: "USD 21.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wm3Vgra0g",
              },
              {
                title: "イギリス領ヴァージン諸島 1GB",
                price: "USD 35.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/n1pwgXXNL",
              },
            ],
            VC: [
              {
                title: "セントビンセント・グレナディーン 500MB",
                price: "USD 21.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGaBzy",
              },
              {
                title: "セントビンセント・グレナディーン 1GB",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391LL9N",
              },
            ],
            AR: [
              {
                title: "アルゼンチン 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZYv098g11",
              },
              {
                title: "アルゼンチン 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Gp60RwwaZ",
              },
            ],
            BR: [
              {
                title: "ブラジル 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/BAaQDYX2z",
              },
              {
                title: "ブラジル 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3dXR6GGZQ",
              },
            ],
            PE: [
              {
                title: "ペルー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/7DXaOReYK",
              },
              {
                title: "ペルー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/57wKXnMRl",
              },
            ],
            CO: [
              {
                title: "コロンビア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2dw8ZR6XA",
              },
              {
                title: "コロンビア 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/r1ObgNYeV",
              },
            ],
            UY: [
              {
                title: "ウルグアイ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/57wKXMmmo",
              },
              {
                title: "ウルグアイ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8Z2XN5",
              },
            ],
            VE: [
              {
                title: "ベネズエラ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/N8v0ZanoZ",
              },
              {
                title: "ベネズエラ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/v1EDgPKoQ",
              },
            ],
            GY: [
              {
                title: "ガイアナ 500MB",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9vbdeZNEN",
              },
              {
                title: "ガイアナ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/mLm9XKL49",
              },
            ],
            PA: [
              {
                title: "パナマ 500MB",
                price: "USD 9.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kMVO68gZ1",
              },
              {
                title: "パナマ 1GB",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/oDPEgKDP1",
              },
            ],
            CL: [
              {
                title: "チリ 500MB",
                price: "USD 11.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6XrNGaZwy",
              },
              {
                title: "チリ 1GB",
                price: "USD 20.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/40391Oayo",
              },
            ],
            BO: [
              {
                title: "ボリビア 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Gp60Rgb42",
              },
              {
                title: "ボリビア 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XYm03Eogy",
              },
            ],
            CR: [
              {
                title: "コスタリカ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYB13bL",
              },
              {
                title: "コスタリカ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J6L0N2vz7",
              },
            ],
            SR: [
              {
                title: "スリナム 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3dXR6r4KY",
              },
              {
                title: "スリナム 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/La40A8Kr7",
              },
            ],
            EC: [
              {
                title: "エクアドル 500MB",
                price: "USD 16",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XYm03b4oy",
              },
              {
                title: "エクアドル 1GB",
                price: "USD 27.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XYm03Ee92",
              },
            ],
            DO: [
              {
                title: "ドミニカ共和国 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e2N0KwG36",
              },
              {
                title: "ドミニカ共和国 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2dw8ZR2KA",
              },
            ],
            GT: [
              {
                title: "グアテマラ 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wm3VgrpQV",
              },
              {
                title: "グアテマラ 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1mzBd3ewQ",
              },
            ],
            NI: [
              {
                title: "ニカラグア 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/E8rYB15Ly",
              },
              {
                title: "ニカラグア 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6XrNGerQM",
              },
            ],
            SV: [
              {
                title: "サルバドール 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/OLE06D4bL",
              },
              {
                title: "サルバドール 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/y8PBgLPwl",
              },
            ],
          },
        },
      },
    };
  },
  methods: {
    changeTab(inputArea) {
      this.area = inputArea;
      for (let a in this.activeTab) {
        this.activeTab[a] = false;
      }
      this.activeTab[this.area] = true;
    },
    changeCountry(countryCode) {
      this.selectedCountry = countryCode;
    },
    changeLanguage(lang) {
      this.language = lang;
      // lang: this.$store.state.lang, // get lang 預設值 `en`
      console.log(this.$i18n.locale);
      this.$i18n.locale = lang;
      this.showLangList = false;
      this.selectedPlans = this.plans[this.currency][this.language]
        ? this.plans[this.currency][this.language]
        : this.plans[this.currency]["en"];
    },
    changeCurrency(currency) {
      this.currency = currency;
      this.showCurrencyList = false;
      this.selectedPlans = this.plans[this.currency][this.language]
        ? this.plans[this.currency][this.language]
        : this.plans[this.currency]["en"];
    },
    gotoPage(currency) {
      let self = this;
      // this.$router.push(currency);
      self.$router.push({
        path: "/" + currency /*, query: { plan: 'private' } */,
      });
    },
    toggleLangList() {
      this.showLangList = !this.showLangList;
    },
    toggleCurrencyList() {
      this.showCurrencyList = !this.showCurrencyList;
    },
  },
  created() {
    // taiwan default
    // this.changeLanguage("tw");
    // this.changeCurrency("NTD");

    // 海外 default
    this.changeLanguage("en");
    this.changeCurrency("USD");

    if (this.$route.query.d) {
      if (this.replaceMap[this.$route.query.d])
        this.distributor = this.$route.query.d;
    }
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 10px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
